webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(356);
	
	__webpack_require__(378);
	
	__webpack_require__(377);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(384);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Router = __webpack_require__(28);
	
	var _AppData = __webpack_require__(7);
	
	var _AppData2 = _interopRequireDefault(_AppData);
	
	var _vueCookie = __webpack_require__(382);
	
	var _vueCookie2 = _interopRequireDefault(_vueCookie);
	
	var _vueResource = __webpack_require__(422);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _veeValidate = __webpack_require__(48);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _api = __webpack_require__(29);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vueTables = __webpack_require__(234);
	
	var _vueTables2 = _interopRequireDefault(_vueTables);
	
	var _Moment = __webpack_require__(1);
	
	var _Moment2 = _interopRequireDefault(_Moment);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	_vue2.default.use(_vueCookie2.default);
	_vue2.default.use(_veeValidate2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueTables2.default.client);
	_vue2.default.config.debug = true;
	
	_vue2.default.component('details-link', {
		props: ['id'],
		template: '<button v-on:click="goDetails">View</button>',
		methods: {
			goDetails: function goDetails(e) {
				_Router.router.push({ path: 'academy/' + this.id });
				e.preventDefault();
			}
		}
	});
	
	_vue2.default.component('loading-bar', {
		template: '<div class="loading"><div class="loading-bar"></div><div class="loading-bar"></div><div class="loading-bar"></div><div class="loading-bar"></div><span>Loading</span></div>'
	});
	
	_vue2.default.directive('timestamp', {
		inserted: function inserted(el, binding) {
			el.innerText = (0, _Moment2.default)(binding.value).format('LLL');
		}
	});
	
	_vue2.default.component('confirm', {
		template: '#confirm-template'
	});
	
	new _vue2.default({
		el: '#app',
		template: '<App/>',
		router: _Router.router,
		store: _AppData2.default,
		components: { App: _App2.default }
	});
	
	window.api = _api2.default;
	_api2.default.getAppVersion();

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(425);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _q = __webpack_require__(164);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _api = __webpack_require__(29);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	_vue2.default.use(_vuex2.default);
	
	var getAcademtData = function getAcademtData(first, mappings) {
		return {
			'id': first.acadid,
			'name': first.acadname,
			'company': first.company,
			'lastrun': first.lastrun,
			'mappings': mappings
		};
	};
	
	exports.default = new _vuex2.default.Store({
		state: {
			user: {
				authenticated: false,
				name: null
			},
			academies: [],
			academiesList: [],
			academiesError: '',
			acadimiesUpdated: null,
			academiesLoaded: false,
	
			usermappings: {
				data: null,
				pollCount: 0,
				ready: false,
				msg: '',
				details: null
			},
			config: {
				hridSync: true,
				ascSync: false,
				hridPush: false,
				delay: {
					enabled: true,
					days: 1
				},
				ignores: [],
				paytype: {
					hourly: [],
					salary: []
				},
				excludeJobs: []
			},
			status: {
				lastSync: null,
				status: null
			},
			app: {
				title: 'HotSchedules Integration Administration',
				version: '',
				loading: false,
				suppressLoading: false
			},
			sync: {
				syncing: false,
				count: 0,
				error: null
	
			},
			activity: {
				log: [],
				offset: 0,
				end: false,
				filter: null
			},
			jobswap: {
				list: [],
				ready: false,
				pollCount: 0,
				msg: null
			},
			paytype: {
				list: [],
				ready: false,
				pollCount: 0,
				msg: null
			},
			troubleshooting: {
				searching: false
			},
			hierarchy: {
				store: null,
				err: null
			},
			mapping: {
				step: 0,
				error: null,
				academy: null,
				ecr: null,
				location: null,
				completed: null
			},
			dataError: null
		},
		mutations: {
			log: function log(response) {
				console.log('mutation called with', response.body, response);
			},
			setVersion: function setVersion(state, data) {
				state.app.version = data.ver;
			},
	
			setLoggedIn: function setLoggedIn(state, username) {
				state.user.authenticated = true;
				state.user.name = username;
			},
			setLoggedOut: function setLoggedOut(state) {
				state.user.authenticated = false;
			},
			addAcademy: function addAcademy(state, academies) {
				var grouped = _underscore2.default.groupBy(academies, 'acadid');
	
				state.academies = academies;
				state.academiesLoaded = true;
				state.app.loading = false;
				state.academiesUpdated = Math.round(new Date().getTime() / 1000);
				state.academiesList = _underscore2.default.reduce(grouped, function (acadList, acad) {
					acadList.push(getAcademtData(acad[0], acad));
					return acadList;
				}, []);
			},
			addJobsList: function addJobsList(state, response) {
				if (_underscore2.default.isArray(response)) {
					state.jobswap.ready = true;
					state.jobswap.list = response;
				} else {
					state.jobswap.msg = response.message;
					state.jobswap.ready = false;
				}
				state.jobswap.pollCount++;
			},
			addJobsPayList: function addJobsPayList(state, response) {
				if (_underscore2.default.isArray(response)) {
					state.paytype.ready = true;
					state.paytype.list = response;
				} else {
					state.paytype.msg = response.message;
					state.paytype.ready = false;
				}
				state.paytype.pollCount++;
			},
			addLogEntries: function addLogEntries(state, entries) {
				state.app.loading = false;
				state.activity.end = !entries.logs.length;
				_underscore2.default.each(entries.logs, function (row) {
					state.activity.log.push(row);
				});
				state.activity.offset = state.activity.log.length;
			},
			setSuppressLoading: function setSuppressLoading(state, b) {
				state.app.suppressLoading = b;
			},
			syncing: function syncing(state, action) {
				state.sync.syncing = true;
				state.sync.action = action;
			},
			syncDone: function syncDone(state, error) {
				state.sync.action = null;
				state.sync.error = error;
			},
			lookup: function lookup(state, response) {
				console.log('user lookup returned', response.body);
				state.troubleshooting.searching = false;
			},
			setAcademyConfig: function setAcademyConfig(state, response) {
				state.config = response;
			},
			setUserMappings: function setUserMappings(state, response) {
				if (!_underscore2.default.isArray(response)) {
					state.usermappings.pollCount++;
					state.usermappings.ready = false;
					state.usermappings.msg = response.message;
				} else {
					state.usermappings.pollCount = 0;
					state.usermappings.ready = true;
					state.usermappings.data = response;
					state.troubleshooting.searching = false;
				}
			},
			setUserDetails: function setUserDetails(state, response) {
				console.log('setUserDetails', response);
				state.usermappings.details = response;
			},
			setStatus: function setStatus(state, response) {
				state.status = response;
				if (state.status.syncAvailable) {
					state.sync.syncing = false;
					state.sync.count = 0;
				} else {
					state.sync.count++;
				}
			},
			syncStatus: function syncStatus(state, response) {
				state.status = response;
				if (state.status.syncAvailable) {
					state.sync.syncing = false;
					state.sync.count = 0;
				} else {
					state.sync.count++;
				}
			},
			setAcademyInfo: function setAcademyInfo(state, response) {
				if (response && response.acadid) {
					state.mapping.academy = response;
					state.mapping.error = null;
					state.mapping.step = 1;
				} else {
					state.mapping.error = 'Academy not found';
				}
			},
			createNewMapping: function createNewMapping(state, response) {
				state.mapping.completed = response;
				state.mapping.step = 4;
			},
			setExtCompRef: function setExtCompRef(state, response) {
				if (_underscore2.default.isString(response)) {
					state.mapping.error = 'could not find root node for extCompRef';
				} else {
					state.mapping.ecr = response;
					state.mapping.error = null;
					state.mapping.location = response.nodes[0];
					state.mapping.step = 2;
				}
			},
			clearMappingError: function clearMappingError(state) {
				state.mapping.error = null;
			},
			setNewMappingStep: function setNewMappingStep(state, step) {
				state.mapping.step = step;
			},
			setNewMappingLocation: function setNewMappingLocation(state, loc) {
				state.mapping.location = loc;
			},
			clearNewMappingData: function clearNewMappingData(state) {
				state.mapping = {
					step: 0,
					error: null,
					academy: null,
					ecr: null,
					location: null,
					completed: null
				};
			},
			removeMapping: function removeMapping(state, response) {
				var acad = _underscore2.default.findWhere(state.academiesList, { id: response.acadid });
				if (!acad) return;
				var n = _underscore2.default.findIndex(acad.mappings, function (m) {
					return m.extCompRef === response.mapping.extCompRef;
				});
	
				if (n !== -1) {
					acad.mappings.splice(n, 1);
				}
			},
			removeAllMappings: function removeAllMappings(state, response) {
				var acad = _underscore2.default.findWhere(state.academiesList, { id: response.acadid });
				if (acad) {
					acad.mappings = [];
				}
			},
			setDataError: function setDataError(state, msg) {
				state.dataError = msg;
			},
			clearDataError: function clearDataError(state) {
				state.dataError = null;
			},
			setHierarchyStore: function setHierarchyStore(state, response) {
				console.log('HIERACHY RESPONSE', response);
				state.hierarchy.store = response.store;
				state.hierarchy.err = response.err;
			}
		},
		actions: {
			setActivityFilter: function setActivityFilter(store, filter) {
				if (store.state.activity.filter !== filter) {
					store.state.activity.offset = 0;
					store.state.activity.end = false;
					store.state.activity.filter = filter;
					store.state.activity.log = [];
				}
			},
			getAcademyConfig: function getAcademyConfig(store, acadid) {
				return _api2.default.getAcademyConfig(acadid);
			},
			getAcademies: function getAcademies(store, context) {
				store.state.app.loading = true;
				return _api2.default.getAcadList();
			},
			getAppVersion: function getAppVersion(store, context) {
				return _api2.default.getAppVersion();
			},
			getLogEntries: function getLogEntries(store, context) {
				if (store.state.activity.end) {
					return (0, _q2.default)();
				}
	
				store.state.app.loading = true;
				return _api2.default.getLogEntries(store.state.activity.offset, store.state.activity.filter);
			},
			getJobsList: function getJobsList(store, acadid) {
				if (store.state.jobswap.ready) {
					store.state.jobswap.pollCount = 0;
					store.state.jobswap.ready = false;
				}
				if (!acadid) {
					return true;
				}
				return _api2.default.getJobsList(acadid);
			},
			getJobPaytypes: function getJobPaytypes(store, acadid) {
				if (store.state.paytype.ready) {
					store.state.paytype.pollCount = 0;
					store.state.paytype.ready = false;
				}
				if (!acadid) {
					return true;
				}
				return _api2.default.getJobsPayList(acadid);
			},
			userlookup: function userlookup(store, query) {
				store.state.troubleshooting.searching = true;
				return _api2.default.getUser(query);
			},
			updateJobsList: function updateJobsList(store, data) {
				return _api2.default.setJobMappings(data.id, data.mappings);
			},
	
			setHRIDsync: function setHRIDsync(store, data) {
				return _api2.default.setHRIDsync(data.id, data.action);
			},
			setASCsync: function setASCsync(store, data) {
				return _api2.default.setASCsync(data.id, data.action);
			},
			setHRIDpush: function setHRIDpush(store, data) {
				return _api2.default.setHRIDpush(data.id, data.action);
			},
			addIgnores: function addIgnores(store, data) {
				var ignores = _underscore2.default._.uniq(data.ignores.concat(store.state.config.ignores));
				return _api2.default.updateIgnores(data.id, ignores);
			},
			removeIgnore: function removeIgnore(store, data) {
				var ignores = _underscore2.default.without(store.state.config.ignores, data.ignore);
				return _api2.default.updateIgnores(data.id, ignores);
			},
			setDelayRemoval: function setDelayRemoval(store, data) {
				return _api2.default.setDelayRemoval(data.id, data.action, data.days);
			},
			updatePayType: function updatePayType(store, data) {
				return _api2.default.updatePayType(data.id, data.hourly);
			},
			updateExcluded: function updateExcluded(store, data) {
				return _api2.default.updateExcluded(data.id, data.excludeJobs);
			},
			getUserMappings: function getUserMappings(store, data) {
				if (store.state.usermappings.ready) {
					store.state.usermappings.pollCount = 0;
					store.state.usermappings.ready = false;
				}
				store.state.troubleshooting.searching = true;
				return _api2.default.getUserMappings(data.id);
			},
			getUserDetails: function getUserDetails(store, data) {
				store.state.usermappings.details = null;
				return _api2.default.getUserDetails(data.acadid, data.schooxid, data.hsids);
			},
			clearUserMappings: function clearUserMappings(store) {
				store.state.usermappings.pollCount = 0;
				store.state.usermappings.ready = false;
				store.state.usermappings.data = [];
				store.state.troubleshooting.searching = false;
			},
			clearUserDetails: function clearUserDetails(store) {
				store.state.usermappings.details = null;
			},
			clearJobs: function clearJobs(store) {
				store.state.paytype.pollCount = 0;
				store.state.paytype.ready = false;
				store.state.paytype.list = [];
				store.state.jobswap.pollCount = 0;
				store.state.jobswap.ready = false;
				store.state.jobswap.list = [];
			},
			getStatus: function getStatus(store, acadid) {
				return _api2.default.getStatus(acadid);
			},
			sync: function sync(store, acadid) {
				store.state.sync.syncing = true;
				store.state.sync.count = 1;
				return _api2.default.sync(acadid);
			},
			delink: function delink(store, data) {
				return _api2.default.delink(data.acadid, data.user);
			},
			acadLookup: function acadLookup(store, acadid) {
				store.state.mapping.error = null;
				return _api2.default.acadLookup(acadid);
			},
			getExtCompRef: function getExtCompRef(store, extCompRef) {
				store.state.mapping.error = null;
				return _api2.default.getExtCompRef(extCompRef);
			},
			createNewMapping: function createNewMapping(store, data) {
				return _api2.default.createNewMapping(data);
			},
			removeMapping: function removeMapping(store, data) {
				return _api2.default.removeMapping(data.acadid, data.mapping);
			},
			removeAllMappings: function removeAllMappings(store, data) {
				return _api2.default.removeAllMappings(data.acadid);
			},
			getHierarchyStore: function getHierarchyStore(store, data) {
				return _api2.default.getHierarchyStore(data.extCompRef, data.storeId);
			},
			clearHierarchyStore: function clearHierarchyStore(store) {
				store.state.hierarchy.stores = null;
				store.state.hierarchy.err = null;
			}
		}
	});

/***/ },
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Router = __webpack_require__(28);
	
	var _AppData = __webpack_require__(7);
	
	var _AppData2 = _interopRequireDefault(_AppData);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var IS_LOCAL = ("production") !== 'production';
	var API_BASE_URL = IS_LOCAL ? 'http://localhost:9000/' : '';
	var LOGIN_URL = API_BASE_URL + 'login';
	var REFRESH_URL = API_BASE_URL + 'refresh';
	exports.default = {
		loginAttempted: false,
		refresh: function refresh(next) {
			var _this = this;
	
			this.loginAttempted = true;
			var token = localStorage.getItem('id_token');
	
			if (token) {
				return _vue2.default.http.get(REFRESH_URL, {
					headers: this.getAuthHeader()
				}).then(function (response) {
					localStorage.setItem('id_token', response.body.access_token);
					_AppData2.default.commit('setLoggedIn', response.body.display_name);
					next();
				}, function (response) {
					_this.logout();
					next();
				});
			} else {
				next();
			}
		},
		login: function login(context, creds) {
			var redirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
	
			this.loginAttempted = true;
			context.$http.post(LOGIN_URL, creds).then(function (response) {
				localStorage.setItem('id_token', response.body.access_token);
				_AppData2.default.commit('setLoggedIn', response.body.display_name);
				if (redirect) {
					console.log('Should go');
					_Router.router.push(redirect);
				}
			}, function (response) {
				context.error = response.body;
				context.formSubmitted = false;
			});
		},
		logout: function logout() {
			console.log('logout');
			localStorage.removeItem('id_token');
			_AppData2.default.commit('setLoggedOut');
			_Router.router.push('/login');
		},
		getAuthHeader: function getAuthHeader() {
			return {
				'Authorization': 'Bearer ' + localStorage.getItem('id_token')
			};
		}
	};

/***/ },
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.router = undefined;
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(423);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Home = __webpack_require__(389);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _List = __webpack_require__(391);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Login = __webpack_require__(392);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Troubleshooting = __webpack_require__(396);
	
	var _Troubleshooting2 = _interopRequireDefault(_Troubleshooting);
	
	var _TroubleshootingLoc = __webpack_require__(397);
	
	var _TroubleshootingLoc2 = _interopRequireDefault(_TroubleshootingLoc);
	
	var _ActivityLog = __webpack_require__(387);
	
	var _ActivityLog2 = _interopRequireDefault(_ActivityLog);
	
	var _MappingTool = __webpack_require__(393);
	
	var _MappingTool2 = _interopRequireDefault(_MappingTool);
	
	var _AcademySearch = __webpack_require__(386);
	
	var _AcademySearch2 = _interopRequireDefault(_AcademySearch);
	
	var _auth = __webpack_require__(20);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _Academy = __webpack_require__(385);
	
	var _Academy2 = _interopRequireDefault(_Academy);
	
	var _AppData = __webpack_require__(7);
	
	var _AppData2 = _interopRequireDefault(_AppData);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	_vue2.default.use(_vueRouter2.default);
	
	var reqAuth = { requiresAuth: true };
	
	var routes = [{ path: '/', component: _Home2.default, meta: reqAuth }, { path: '/home', component: _Home2.default, meta: reqAuth }, { path: '/login', component: _Login2.default }, { path: '/list', component: _List2.default, meta: reqAuth }, { path: '/academy/:id', component: _Academy2.default, meta: reqAuth }, { name: 'mapping', path: '/mapping', component: _MappingTool2.default, meta: reqAuth }, { path: '/search', component: _AcademySearch2.default, meta: reqAuth }, { path: '/log', component: _ActivityLog2.default, meta: reqAuth }, { name: 'troubleshooting', path: '/troubleshooting', component: _Troubleshooting2.default, meta: reqAuth }, { name: 'troubleshootingloc', path: '/troubleshootingloc', component: _TroubleshootingLoc2.default, meta: reqAuth }];
	
	var router = exports.router = new _vueRouter2.default({
		routes: routes
	});
	
	router.beforeEach(function (to, from, next) {
		if (!_auth2.default.loginAttempted) {
			_auth2.default.refresh(next);
		} else {
			_AppData2.default.commit('clearDataError');
			next();
		}
	});
	
	router.beforeEach(function (to, from, next) {
		if (to.matched.some(function (record) {
			return record.meta.requiresAuth;
		}) && !_AppData2.default.state.user.authenticated) {
			next({ path: '/login' });
		} else {
			next();
		}
	});

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _auth = __webpack_require__(20);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _AppData = __webpack_require__(7);
	
	var _AppData2 = _interopRequireDefault(_AppData);
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _axios = __webpack_require__(191);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var IS_LOCAL = ("production") !== 'production';
	var APP_ROOT = IS_LOCAL ? 'http://localhost:9000/' : '';
	var API_URL = IS_LOCAL ? APP_ROOT + 'api/' : 'api/';
	var VERSION_URL = APP_ROOT + 'version';
	var ACADEMY_MAPPING_URL = API_URL + 'mappings';
	var ACTIVITY_LOG_URL = API_URL + 'logs';
	var USER_LOOKUP_URL = API_URL + 'userlookup';
	var EXT_COMP_REF_URL = API_URL + 'extCompRef/';
	
	var academyActionURL = function academyActionURL(acadid, action) {
		var url = API_URL + 'academy/' + acadid;
		if (action) url += '/' + action;
		return url;
	};
	
	var makeOptions = function makeOptions(timeout) {
		return {
			headers: _auth2.default.getAuthHeader(),
			timeout: timeout
		};
	};
	
	var handleError = function handleError(error, handler) {
		var msg = 'Data retrieval error detected.';
		if (error.response) {
			console.log(error.response.data);
			console.log(error.response.status);
			console.log(error.response.headers);
		} else if (error.request) {
			console.log(error.request);
		} else {
			console.log('Error', error.message);
		}
	
		if (handler) {
			msg += ' Attempting retry. ';
			handler().then(function () {
				_AppData2.default.commit('clearDataError');
			});
		}
		_AppData2.default.commit('setDataError', msg);
		console.log(error.config);
	};
	
	var post = function post(url, data, action) {
		var reqAuth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
		var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 60000;
	
		var options = reqAuth ? makeOptions(timeout) : null;
	
		return _axios2.default.post(url, data, options).then(function (response) {
			if (action) {
				_AppData2.default.commit(action, response.data);
			}
			return response;
		}).catch(handleError);
	};
	
	var get = function get(url, action) {
		var reqAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
		var errfunc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
		var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 60000;
	
		console.log('URL', url);
		var options = reqAuth ? makeOptions(timeout) : null;
	
		return _axios2.default.get(url, options).then(function (response) {
			_AppData2.default.commit(action, response.data);
			return response;
		}).catch(handleError, errfunc);
	};
	
	var api = {
		getAcadList: function getAcadList() {
			return get(ACADEMY_MAPPING_URL, 'addAcademy');
		},
		getAppVersion: function getAppVersion() {
			return get(VERSION_URL, 'setVersion', false);
		},
		getAcademyConfig: function getAcademyConfig(acadid) {
			return get(academyActionURL(acadid, 'config'), 'setAcademyConfig');
		},
		getLogEntries: function getLogEntries(offset, filter) {
			var url = ACTIVITY_LOG_URL + '/' + offset;
			if (filter) {
				url += '?filter=' + filter;
			}
			return get(url, 'addLogEntries');
		},
		getJobsList: function getJobsList(acadid) {
			return get(academyActionURL(acadid, 'jobsWithoutSwap'), 'addJobsList', true, function () {
				return api.getJobsList(acadid);
			});
		},
		getJobsPayList: function getJobsPayList(acadid) {
			return get(academyActionURL(acadid, 'jobsWithSwap'), 'addJobsPayList', true, function () {
				return api.getJobsPayList(acadid);
			});
		},
		getStatus: function getStatus(acadid) {
			return get(academyActionURL(acadid, 'status'), 'setStatus', true, function () {
				return api.getStatus(acadid);
			});
		},
		sync: function sync(acadid) {
			return get(academyActionURL(acadid, 'sync'), 'syncStatus');
		},
		acadLookup: function acadLookup(acadid) {
			return get(academyActionURL(acadid), 'setAcademyInfo');
		},
		getExtCompRef: function getExtCompRef(ref) {
			var url = EXT_COMP_REF_URL + ref;
			return get(url, 'setExtCompRef');
		},
		setHRIDsync: function setHRIDsync(acadid, action) {
			return post(academyActionURL(acadid, 'hridsync'), {
				action: action
			}, 'setAcademyConfig');
		},
		setASCsync: function setASCsync(acadid, action) {
			return post(academyActionURL(acadid, 'ascsync'), {
				action: action
			}, 'setAcademyConfig');
		},
		setHRIDpush: function setHRIDpush(acadid, action) {
			return post(academyActionURL(acadid, 'hridpush'), {
				action: action
			}, 'setAcademyConfig');
		},
		setDelayRemoval: function setDelayRemoval(acadid, action, days) {
			if (action === true && !_underscore2.default.isNumber(days)) {
				days = 1;
			}
			return post(academyActionURL(acadid, 'delaydays'), {
				action: action,
				days: days
			}, 'setAcademyConfig');
		},
		updateIgnores: function updateIgnores(acadid, ignores) {
			return post(academyActionURL(acadid, 'ignores'), {
				acadid: acadid,
				ignores: ignores
			}, 'setAcademyConfig');
		},
		setJobMappings: function setJobMappings(acadid, map) {
			return post(academyActionURL(acadid, 'jobmappings'), {
				acadid: acadid,
				swapJobs: map
			}, 'setAcademyConfig');
		},
		updatePayType: function updatePayType(acadid, hourly) {
			return post(academyActionURL(acadid, 'paytype'), hourly, 'setAcademyConfig');
		},
		updateExcluded: function updateExcluded(acadid, excludeJobs) {
			return post(academyActionURL(acadid, 'exclude'), excludeJobs, 'setAcademyConfig');
		},
		removeMapping: function removeMapping(acadid, mapping) {
			return post(academyActionURL(acadid, 'removemapping'), mapping, 'removeMapping');
		},
		removeAllMappings: function removeAllMappings(acadid) {
			return post(academyActionURL(acadid, 'removeallmappings'), {}, 'removeAllMappings');
		},
		getUser: function getUser(query) {
			return post(USER_LOOKUP_URL, {
				query: query
			}, 'lookup');
		},
		getUserMappings: function getUserMappings(acadid) {
			return post(academyActionURL(acadid, 'newusermappings'), {}, 'setUserMappings');
		},
		getHierarchyStore: function getHierarchyStore(extCompRef, storeId) {
			return post(API_URL + 'hierarchy/nodeLookup', {
				extCompRef: extCompRef,
				storeId: storeId
			}, 'setHierarchyStore');
		},
		getUserDetails: function getUserDetails(acadid, schooxid, hsids) {
			return post(academyActionURL(acadid, 'userlookup'), {
				userid: schooxid,
				hsids: hsids
			}, 'setUserDetails');
		},
		test: function test() {
			return get('api/test', 'log');
		},
		delink: function delink(acadid, user) {
			return post(academyActionURL(acadid, 'delink'), user, 'log');
		},
		createNewMapping: function createNewMapping(data) {
			return post(academyActionURL(data.acadid, 'makemapping'), data, 'createNewMapping');
		},
		confirmMapping: function confirmMapping(acadid, mapping) {
			return post(academyActionURL(acadid, 'confirmMapping'), mapping, 'onMappingConfirm');
		},
		getMissMatchReport: function getMissMatchReport(acadid) {
			return _axios2.default.post(API_URL + 'academy/' + acadid + '/mismatchedNames.csv', {}, {
				headers: _auth2.default.getAuthHeader(),
				timeout: 10000,
				responseType: 'blob'
			}).then(function (response) {
				var result = document.createElement('a');
				result.href = window.URL.createObjectURL(response.data);
				result.download = 'mismatchedNames.csv';
				return result;
			}).then(function (link) {
				link.click();
			});
		}
	};
	
	exports.default = api;

/***/ },
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, module) {"use strict";
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty = __webpack_require__(177);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _create = __webpack_require__(313);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _setImmediate2 = __webpack_require__(314);
	
	var _setImmediate3 = _interopRequireDefault(_setImmediate2);
	
	var _typeof2 = __webpack_require__(32);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	(function (definition) {
	    "use strict";
	
	    if (typeof bootstrap === "function") {
	        bootstrap("promise", definition);
	    } else if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object" && ( false ? "undefined" : (0, _typeof3.default)(module)) === "object") {
	        module.exports = definition();
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof ses !== "undefined") {
	        if (!ses.ok()) {
	            return;
	        } else {
	            ses.makeQ = definition;
	        }
	    } else if (typeof window !== "undefined" || typeof self !== "undefined") {
	        var global = typeof window !== "undefined" ? window : self;
	
	        var previousQ = global.Q;
	        global.Q = definition();
	
	        global.Q.noConflict = function () {
	            global.Q = previousQ;
	            return this;
	        };
	    } else {
	        throw new Error("This environment was not anticipated by Q. Please file a bug.");
	    }
	})(function () {
	    "use strict";
	
	    var hasStacks = false;
	    try {
	        throw new Error();
	    } catch (e) {
	        hasStacks = !!e.stack;
	    }
	
	    var qStartingLine = captureLine();
	    var qFileName;
	
	    var noop = function noop() {};
	
	    var nextTick = function () {
	        var head = { task: void 0, next: null };
	        var tail = head;
	        var flushing = false;
	        var requestTick = void 0;
	        var isNodeJS = false;
	
	        var laterQueue = [];
	
	        function flush() {
	            var task, domain;
	
	            while (head.next) {
	                head = head.next;
	                task = head.task;
	                head.task = void 0;
	                domain = head.domain;
	
	                if (domain) {
	                    head.domain = void 0;
	                    domain.enter();
	                }
	                runSingle(task, domain);
	            }
	            while (laterQueue.length) {
	                task = laterQueue.pop();
	                runSingle(task);
	            }
	            flushing = false;
	        }
	
	        function runSingle(task, domain) {
	            try {
	                task();
	            } catch (e) {
	                if (isNodeJS) {
	                    if (domain) {
	                        domain.exit();
	                    }
	                    setTimeout(flush, 0);
	                    if (domain) {
	                        domain.enter();
	                    }
	
	                    throw e;
	                } else {
	                    setTimeout(function () {
	                        throw e;
	                    }, 0);
	                }
	            }
	
	            if (domain) {
	                domain.exit();
	            }
	        }
	
	        nextTick = function nextTick(task) {
	            tail = tail.next = {
	                task: task,
	                domain: isNodeJS && process.domain,
	                next: null
	            };
	
	            if (!flushing) {
	                flushing = true;
	                requestTick();
	            }
	        };
	
	        if ((typeof process === "undefined" ? "undefined" : (0, _typeof3.default)(process)) === "object" && process.toString() === "[object process]" && process.nextTick) {
	            isNodeJS = true;
	
	            requestTick = function requestTick() {
	                process.nextTick(flush);
	            };
	        } else if (typeof _setImmediate3.default === "function") {
	            if (typeof window !== "undefined") {
	                requestTick = _setImmediate3.default.bind(window, flush);
	            } else {
	                requestTick = function requestTick() {
	                    (0, _setImmediate3.default)(flush);
	                };
	            }
	        } else if (typeof MessageChannel !== "undefined") {
	            var channel = new MessageChannel();
	
	            channel.port1.onmessage = function () {
	                requestTick = requestPortTick;
	                channel.port1.onmessage = flush;
	                flush();
	            };
	            var requestPortTick = function requestPortTick() {
	                channel.port2.postMessage(0);
	            };
	            requestTick = function requestTick() {
	                setTimeout(flush, 0);
	                requestPortTick();
	            };
	        } else {
	            requestTick = function requestTick() {
	                setTimeout(flush, 0);
	            };
	        }
	
	        nextTick.runAfter = function (task) {
	            laterQueue.push(task);
	            if (!flushing) {
	                flushing = true;
	                requestTick();
	            }
	        };
	        return nextTick;
	    }();
	
	    var call = Function.call;
	    function uncurryThis(f) {
	        return function () {
	            return call.apply(f, arguments);
	        };
	    }
	
	    var array_slice = uncurryThis(Array.prototype.slice);
	
	    var array_reduce = uncurryThis(Array.prototype.reduce || function (callback, basis) {
	        var index = 0,
	            length = this.length;
	
	        if (arguments.length === 1) {
	            do {
	                if (index in this) {
	                    basis = this[index++];
	                    break;
	                }
	                if (++index >= length) {
	                    throw new TypeError();
	                }
	            } while (1);
	        }
	
	        for (; index < length; index++) {
	            if (index in this) {
	                basis = callback(basis, this[index], index);
	            }
	        }
	        return basis;
	    });
	
	    var array_indexOf = uncurryThis(Array.prototype.indexOf || function (value) {
	        for (var i = 0; i < this.length; i++) {
	            if (this[i] === value) {
	                return i;
	            }
	        }
	        return -1;
	    });
	
	    var array_map = uncurryThis(Array.prototype.map || function (callback, thisp) {
	        var self = this;
	        var collect = [];
	        array_reduce(self, function (undefined, value, index) {
	            collect.push(callback.call(thisp, value, index, self));
	        }, void 0);
	        return collect;
	    });
	
	    var object_create = _create2.default || function (prototype) {
	        function Type() {}
	        Type.prototype = prototype;
	        return new Type();
	    };
	
	    var object_defineProperty = _defineProperty2.default || function (obj, prop, descriptor) {
	        obj[prop] = descriptor.value;
	        return obj;
	    };
	
	    var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
	
	    var object_keys = _keys2.default || function (object) {
	        var keys = [];
	        for (var key in object) {
	            if (object_hasOwnProperty(object, key)) {
	                keys.push(key);
	            }
	        }
	        return keys;
	    };
	
	    var object_toString = uncurryThis(Object.prototype.toString);
	
	    function isObject(value) {
	        return value === Object(value);
	    }
	
	    function isStopIteration(exception) {
	        return object_toString(exception) === "[object StopIteration]" || exception instanceof QReturnValue;
	    }
	
	    var QReturnValue;
	    if (typeof ReturnValue !== "undefined") {
	        QReturnValue = ReturnValue;
	    } else {
	        QReturnValue = function QReturnValue(value) {
	            this.value = value;
	        };
	    }
	
	    var STACK_JUMP_SEPARATOR = "From previous event:";
	
	    function makeStackTraceLong(error, promise) {
	        if (hasStacks && promise.stack && (typeof error === "undefined" ? "undefined" : (0, _typeof3.default)(error)) === "object" && error !== null && error.stack) {
	            var stacks = [];
	            for (var p = promise; !!p; p = p.source) {
	                if (p.stack && (!error.__minimumStackCounter__ || error.__minimumStackCounter__ > p.stackCounter)) {
	                    object_defineProperty(error, "__minimumStackCounter__", { value: p.stackCounter, configurable: true });
	                    stacks.unshift(p.stack);
	                }
	            }
	            stacks.unshift(error.stack);
	
	            var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
	            var stack = filterStackString(concatedStacks);
	            object_defineProperty(error, "stack", { value: stack, configurable: true });
	        }
	    }
	
	    function filterStackString(stackString) {
	        var lines = stackString.split("\n");
	        var desiredLines = [];
	        for (var i = 0; i < lines.length; ++i) {
	            var line = lines[i];
	
	            if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
	                desiredLines.push(line);
	            }
	        }
	        return desiredLines.join("\n");
	    }
	
	    function isNodeFrame(stackLine) {
	        return stackLine.indexOf("(module.js:") !== -1 || stackLine.indexOf("(node.js:") !== -1;
	    }
	
	    function getFileNameAndLineNumber(stackLine) {
	        var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
	        if (attempt1) {
	            return [attempt1[1], Number(attempt1[2])];
	        }
	
	        var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
	        if (attempt2) {
	            return [attempt2[1], Number(attempt2[2])];
	        }
	
	        var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
	        if (attempt3) {
	            return [attempt3[1], Number(attempt3[2])];
	        }
	    }
	
	    function isInternalFrame(stackLine) {
	        var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);
	
	        if (!fileNameAndLineNumber) {
	            return false;
	        }
	
	        var fileName = fileNameAndLineNumber[0];
	        var lineNumber = fileNameAndLineNumber[1];
	
	        return fileName === qFileName && lineNumber >= qStartingLine && lineNumber <= qEndingLine;
	    }
	
	    function captureLine() {
	        if (!hasStacks) {
	            return;
	        }
	
	        try {
	            throw new Error();
	        } catch (e) {
	            var lines = e.stack.split("\n");
	            var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
	            var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
	            if (!fileNameAndLineNumber) {
	                return;
	            }
	
	            qFileName = fileNameAndLineNumber[0];
	            return fileNameAndLineNumber[1];
	        }
	    }
	
	    function deprecate(callback, name, alternative) {
	        return function () {
	            if (typeof console !== "undefined" && typeof console.warn === "function") {
	                console.warn(name + " is deprecated, use " + alternative + " instead.", new Error("").stack);
	            }
	            return callback.apply(callback, arguments);
	        };
	    }
	
	    function Q(value) {
	        if (value instanceof Promise) {
	            return value;
	        }
	
	        if (isPromiseAlike(value)) {
	            return coerce(value);
	        } else {
	            return fulfill(value);
	        }
	    }
	    Q.resolve = Q;
	
	    Q.nextTick = nextTick;
	
	    Q.longStackSupport = false;
	
	    var longStackCounter = 1;
	
	    if ((typeof process === "undefined" ? "undefined" : (0, _typeof3.default)(process)) === "object" && process && ({"NODE_ENV":"production"}) && ({"NODE_ENV":"production"}).Q_DEBUG) {
	        Q.longStackSupport = true;
	    }
	
	    Q.defer = defer;
	    function defer() {
	        var messages = [],
	            progressListeners = [],
	            resolvedPromise;
	
	        var deferred = object_create(defer.prototype);
	        var promise = object_create(Promise.prototype);
	
	        promise.promiseDispatch = function (resolve, op, operands) {
	            var args = array_slice(arguments);
	            if (messages) {
	                messages.push(args);
	                if (op === "when" && operands[1]) {
	                    progressListeners.push(operands[1]);
	                }
	            } else {
	                Q.nextTick(function () {
	                    resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
	                });
	            }
	        };
	
	        promise.valueOf = function () {
	            if (messages) {
	                return promise;
	            }
	            var nearerValue = nearer(resolvedPromise);
	            if (isPromise(nearerValue)) {
	                resolvedPromise = nearerValue;
	            }
	            return nearerValue;
	        };
	
	        promise.inspect = function () {
	            if (!resolvedPromise) {
	                return { state: "pending" };
	            }
	            return resolvedPromise.inspect();
	        };
	
	        if (Q.longStackSupport && hasStacks) {
	            try {
	                throw new Error();
	            } catch (e) {
	                promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
	                promise.stackCounter = longStackCounter++;
	            }
	        }
	
	        function become(newPromise) {
	            resolvedPromise = newPromise;
	
	            if (Q.longStackSupport && hasStacks) {
	                promise.source = newPromise;
	            }
	
	            array_reduce(messages, function (undefined, message) {
	                Q.nextTick(function () {
	                    newPromise.promiseDispatch.apply(newPromise, message);
	                });
	            }, void 0);
	
	            messages = void 0;
	            progressListeners = void 0;
	        }
	
	        deferred.promise = promise;
	        deferred.resolve = function (value) {
	            if (resolvedPromise) {
	                return;
	            }
	
	            become(Q(value));
	        };
	
	        deferred.fulfill = function (value) {
	            if (resolvedPromise) {
	                return;
	            }
	
	            become(fulfill(value));
	        };
	        deferred.reject = function (reason) {
	            if (resolvedPromise) {
	                return;
	            }
	
	            become(reject(reason));
	        };
	        deferred.notify = function (progress) {
	            if (resolvedPromise) {
	                return;
	            }
	
	            array_reduce(progressListeners, function (undefined, progressListener) {
	                Q.nextTick(function () {
	                    progressListener(progress);
	                });
	            }, void 0);
	        };
	
	        return deferred;
	    }
	
	    defer.prototype.makeNodeResolver = function () {
	        var self = this;
	        return function (error, value) {
	            if (error) {
	                self.reject(error);
	            } else if (arguments.length > 2) {
	                self.resolve(array_slice(arguments, 1));
	            } else {
	                self.resolve(value);
	            }
	        };
	    };
	
	    Q.Promise = promise;
	    Q.promise = promise;
	    function promise(resolver) {
	        if (typeof resolver !== "function") {
	            throw new TypeError("resolver must be a function.");
	        }
	        var deferred = defer();
	        try {
	            resolver(deferred.resolve, deferred.reject, deferred.notify);
	        } catch (reason) {
	            deferred.reject(reason);
	        }
	        return deferred.promise;
	    }
	
	    promise.race = race;
	    promise.all = all;
	    promise.reject = reject;
	    promise.resolve = Q;
	    Q.passByCopy = function (object) {
	        return object;
	    };
	
	    Promise.prototype.passByCopy = function () {
	        return this;
	    };
	
	    Q.join = function (x, y) {
	        return Q(x).join(y);
	    };
	
	    Promise.prototype.join = function (that) {
	        return Q([this, that]).spread(function (x, y) {
	            if (x === y) {
	                return x;
	            } else {
	                throw new Error("Q can't join: not the same: " + x + " " + y);
	            }
	        });
	    };
	
	    Q.race = race;
	    function race(answerPs) {
	        return promise(function (resolve, reject) {
	            for (var i = 0, len = answerPs.length; i < len; i++) {
	                Q(answerPs[i]).then(resolve, reject);
	            }
	        });
	    }
	
	    Promise.prototype.race = function () {
	        return this.then(Q.race);
	    };
	
	    Q.makePromise = Promise;
	    function Promise(descriptor, fallback, inspect) {
	        if (fallback === void 0) {
	            fallback = function fallback(op) {
	                return reject(new Error("Promise does not support operation: " + op));
	            };
	        }
	        if (inspect === void 0) {
	            inspect = function inspect() {
	                return { state: "unknown" };
	            };
	        }
	
	        var promise = object_create(Promise.prototype);
	
	        promise.promiseDispatch = function (resolve, op, args) {
	            var result;
	            try {
	                if (descriptor[op]) {
	                    result = descriptor[op].apply(promise, args);
	                } else {
	                    result = fallback.call(promise, op, args);
	                }
	            } catch (exception) {
	                result = reject(exception);
	            }
	            if (resolve) {
	                resolve(result);
	            }
	        };
	
	        promise.inspect = inspect;
	
	        if (inspect) {
	            var inspected = inspect();
	            if (inspected.state === "rejected") {
	                promise.exception = inspected.reason;
	            }
	
	            promise.valueOf = function () {
	                var inspected = inspect();
	                if (inspected.state === "pending" || inspected.state === "rejected") {
	                    return promise;
	                }
	                return inspected.value;
	            };
	        }
	
	        return promise;
	    }
	
	    Promise.prototype.toString = function () {
	        return "[object Promise]";
	    };
	
	    Promise.prototype.then = function (fulfilled, rejected, progressed) {
	        var self = this;
	        var deferred = defer();
	        var done = false;
	
	        function _fulfilled(value) {
	            try {
	                return typeof fulfilled === "function" ? fulfilled(value) : value;
	            } catch (exception) {
	                return reject(exception);
	            }
	        }
	
	        function _rejected(exception) {
	            if (typeof rejected === "function") {
	                makeStackTraceLong(exception, self);
	                try {
	                    return rejected(exception);
	                } catch (newException) {
	                    return reject(newException);
	                }
	            }
	            return reject(exception);
	        }
	
	        function _progressed(value) {
	            return typeof progressed === "function" ? progressed(value) : value;
	        }
	
	        Q.nextTick(function () {
	            self.promiseDispatch(function (value) {
	                if (done) {
	                    return;
	                }
	                done = true;
	
	                deferred.resolve(_fulfilled(value));
	            }, "when", [function (exception) {
	                if (done) {
	                    return;
	                }
	                done = true;
	
	                deferred.resolve(_rejected(exception));
	            }]);
	        });
	
	        self.promiseDispatch(void 0, "when", [void 0, function (value) {
	            var newValue;
	            var threw = false;
	            try {
	                newValue = _progressed(value);
	            } catch (e) {
	                threw = true;
	                if (Q.onerror) {
	                    Q.onerror(e);
	                } else {
	                    throw e;
	                }
	            }
	
	            if (!threw) {
	                deferred.notify(newValue);
	            }
	        }]);
	
	        return deferred.promise;
	    };
	
	    Q.tap = function (promise, callback) {
	        return Q(promise).tap(callback);
	    };
	
	    Promise.prototype.tap = function (callback) {
	        callback = Q(callback);
	
	        return this.then(function (value) {
	            return callback.fcall(value).thenResolve(value);
	        });
	    };
	
	    Q.when = when;
	    function when(value, fulfilled, rejected, progressed) {
	        return Q(value).then(fulfilled, rejected, progressed);
	    }
	
	    Promise.prototype.thenResolve = function (value) {
	        return this.then(function () {
	            return value;
	        });
	    };
	
	    Q.thenResolve = function (promise, value) {
	        return Q(promise).thenResolve(value);
	    };
	
	    Promise.prototype.thenReject = function (reason) {
	        return this.then(function () {
	            throw reason;
	        });
	    };
	
	    Q.thenReject = function (promise, reason) {
	        return Q(promise).thenReject(reason);
	    };
	
	    Q.nearer = nearer;
	    function nearer(value) {
	        if (isPromise(value)) {
	            var inspected = value.inspect();
	            if (inspected.state === "fulfilled") {
	                return inspected.value;
	            }
	        }
	        return value;
	    }
	
	    Q.isPromise = isPromise;
	    function isPromise(object) {
	        return object instanceof Promise;
	    }
	
	    Q.isPromiseAlike = isPromiseAlike;
	    function isPromiseAlike(object) {
	        return isObject(object) && typeof object.then === "function";
	    }
	
	    Q.isPending = isPending;
	    function isPending(object) {
	        return isPromise(object) && object.inspect().state === "pending";
	    }
	
	    Promise.prototype.isPending = function () {
	        return this.inspect().state === "pending";
	    };
	
	    Q.isFulfilled = isFulfilled;
	    function isFulfilled(object) {
	        return !isPromise(object) || object.inspect().state === "fulfilled";
	    }
	
	    Promise.prototype.isFulfilled = function () {
	        return this.inspect().state === "fulfilled";
	    };
	
	    Q.isRejected = isRejected;
	    function isRejected(object) {
	        return isPromise(object) && object.inspect().state === "rejected";
	    }
	
	    Promise.prototype.isRejected = function () {
	        return this.inspect().state === "rejected";
	    };
	
	    var unhandledReasons = [];
	    var unhandledRejections = [];
	    var reportedUnhandledRejections = [];
	    var trackUnhandledRejections = true;
	
	    function resetUnhandledRejections() {
	        unhandledReasons.length = 0;
	        unhandledRejections.length = 0;
	
	        if (!trackUnhandledRejections) {
	            trackUnhandledRejections = true;
	        }
	    }
	
	    function trackRejection(promise, reason) {
	        if (!trackUnhandledRejections) {
	            return;
	        }
	        if ((typeof process === "undefined" ? "undefined" : (0, _typeof3.default)(process)) === "object" && typeof process.emit === "function") {
	            Q.nextTick.runAfter(function () {
	                if (array_indexOf(unhandledRejections, promise) !== -1) {
	                    process.emit("unhandledRejection", reason, promise);
	                    reportedUnhandledRejections.push(promise);
	                }
	            });
	        }
	
	        unhandledRejections.push(promise);
	        if (reason && typeof reason.stack !== "undefined") {
	            unhandledReasons.push(reason.stack);
	        } else {
	            unhandledReasons.push("(no stack) " + reason);
	        }
	    }
	
	    function untrackRejection(promise) {
	        if (!trackUnhandledRejections) {
	            return;
	        }
	
	        var at = array_indexOf(unhandledRejections, promise);
	        if (at !== -1) {
	            if ((typeof process === "undefined" ? "undefined" : (0, _typeof3.default)(process)) === "object" && typeof process.emit === "function") {
	                Q.nextTick.runAfter(function () {
	                    var atReport = array_indexOf(reportedUnhandledRejections, promise);
	                    if (atReport !== -1) {
	                        process.emit("rejectionHandled", unhandledReasons[at], promise);
	                        reportedUnhandledRejections.splice(atReport, 1);
	                    }
	                });
	            }
	            unhandledRejections.splice(at, 1);
	            unhandledReasons.splice(at, 1);
	        }
	    }
	
	    Q.resetUnhandledRejections = resetUnhandledRejections;
	
	    Q.getUnhandledReasons = function () {
	        return unhandledReasons.slice();
	    };
	
	    Q.stopUnhandledRejectionTracking = function () {
	        resetUnhandledRejections();
	        trackUnhandledRejections = false;
	    };
	
	    resetUnhandledRejections();
	
	    Q.reject = reject;
	    function reject(reason) {
	        var rejection = Promise({
	            "when": function when(rejected) {
	                if (rejected) {
	                    untrackRejection(this);
	                }
	                return rejected ? rejected(reason) : this;
	            }
	        }, function fallback() {
	            return this;
	        }, function inspect() {
	            return { state: "rejected", reason: reason };
	        });
	
	        trackRejection(rejection, reason);
	
	        return rejection;
	    }
	
	    Q.fulfill = fulfill;
	    function fulfill(value) {
	        return Promise({
	            "when": function when() {
	                return value;
	            },
	            "get": function get(name) {
	                return value[name];
	            },
	            "set": function set(name, rhs) {
	                value[name] = rhs;
	            },
	            "delete": function _delete(name) {
	                delete value[name];
	            },
	            "post": function post(name, args) {
	                if (name === null || name === void 0) {
	                    return value.apply(void 0, args);
	                } else {
	                    return value[name].apply(value, args);
	                }
	            },
	            "apply": function apply(thisp, args) {
	                return value.apply(thisp, args);
	            },
	            "keys": function keys() {
	                return object_keys(value);
	            }
	        }, void 0, function inspect() {
	            return { state: "fulfilled", value: value };
	        });
	    }
	
	    function coerce(promise) {
	        var deferred = defer();
	        Q.nextTick(function () {
	            try {
	                promise.then(deferred.resolve, deferred.reject, deferred.notify);
	            } catch (exception) {
	                deferred.reject(exception);
	            }
	        });
	        return deferred.promise;
	    }
	
	    Q.master = master;
	    function master(object) {
	        return Promise({
	            "isDef": function isDef() {}
	        }, function fallback(op, args) {
	            return dispatch(object, op, args);
	        }, function () {
	            return Q(object).inspect();
	        });
	    }
	
	    Q.spread = spread;
	    function spread(value, fulfilled, rejected) {
	        return Q(value).spread(fulfilled, rejected);
	    }
	
	    Promise.prototype.spread = function (fulfilled, rejected) {
	        return this.all().then(function (array) {
	            return fulfilled.apply(void 0, array);
	        }, rejected);
	    };
	
	    Q.async = async;
	    function async(makeGenerator) {
	        return function () {
	            function continuer(verb, arg) {
	                var result;
	
	                if (typeof StopIteration === "undefined") {
	                    try {
	                        result = generator[verb](arg);
	                    } catch (exception) {
	                        return reject(exception);
	                    }
	                    if (result.done) {
	                        return Q(result.value);
	                    } else {
	                        return when(result.value, callback, errback);
	                    }
	                } else {
	                    try {
	                        result = generator[verb](arg);
	                    } catch (exception) {
	                        if (isStopIteration(exception)) {
	                            return Q(exception.value);
	                        } else {
	                            return reject(exception);
	                        }
	                    }
	                    return when(result, callback, errback);
	                }
	            }
	            var generator = makeGenerator.apply(this, arguments);
	            var callback = continuer.bind(continuer, "next");
	            var errback = continuer.bind(continuer, "throw");
	            return callback();
	        };
	    }
	
	    Q.spawn = spawn;
	    function spawn(makeGenerator) {
	        Q.done(Q.async(makeGenerator)());
	    }
	
	    Q["return"] = _return;
	    function _return(value) {
	        throw new QReturnValue(value);
	    }
	
	    Q.promised = promised;
	    function promised(callback) {
	        return function () {
	            return spread([this, all(arguments)], function (self, args) {
	                return callback.apply(self, args);
	            });
	        };
	    }
	
	    Q.dispatch = dispatch;
	    function dispatch(object, op, args) {
	        return Q(object).dispatch(op, args);
	    }
	
	    Promise.prototype.dispatch = function (op, args) {
	        var self = this;
	        var deferred = defer();
	        Q.nextTick(function () {
	            self.promiseDispatch(deferred.resolve, op, args);
	        });
	        return deferred.promise;
	    };
	
	    Q.get = function (object, key) {
	        return Q(object).dispatch("get", [key]);
	    };
	
	    Promise.prototype.get = function (key) {
	        return this.dispatch("get", [key]);
	    };
	
	    Q.set = function (object, key, value) {
	        return Q(object).dispatch("set", [key, value]);
	    };
	
	    Promise.prototype.set = function (key, value) {
	        return this.dispatch("set", [key, value]);
	    };
	
	    Q.del = Q["delete"] = function (object, key) {
	        return Q(object).dispatch("delete", [key]);
	    };
	
	    Promise.prototype.del = Promise.prototype["delete"] = function (key) {
	        return this.dispatch("delete", [key]);
	    };
	
	    Q.mapply = Q.post = function (object, name, args) {
	        return Q(object).dispatch("post", [name, args]);
	    };
	
	    Promise.prototype.mapply = Promise.prototype.post = function (name, args) {
	        return this.dispatch("post", [name, args]);
	    };
	
	    Q.send = Q.mcall = Q.invoke = function (object, name) {
	        return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
	    };
	
	    Promise.prototype.send = Promise.prototype.mcall = Promise.prototype.invoke = function (name) {
	        return this.dispatch("post", [name, array_slice(arguments, 1)]);
	    };
	
	    Q.fapply = function (object, args) {
	        return Q(object).dispatch("apply", [void 0, args]);
	    };
	
	    Promise.prototype.fapply = function (args) {
	        return this.dispatch("apply", [void 0, args]);
	    };
	
	    Q["try"] = Q.fcall = function (object) {
	        return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
	    };
	
	    Promise.prototype.fcall = function () {
	        return this.dispatch("apply", [void 0, array_slice(arguments)]);
	    };
	
	    Q.fbind = function (object) {
	        var promise = Q(object);
	        var args = array_slice(arguments, 1);
	        return function fbound() {
	            return promise.dispatch("apply", [this, args.concat(array_slice(arguments))]);
	        };
	    };
	    Promise.prototype.fbind = function () {
	        var promise = this;
	        var args = array_slice(arguments);
	        return function fbound() {
	            return promise.dispatch("apply", [this, args.concat(array_slice(arguments))]);
	        };
	    };
	
	    Q.keys = function (object) {
	        return Q(object).dispatch("keys", []);
	    };
	
	    Promise.prototype.keys = function () {
	        return this.dispatch("keys", []);
	    };
	
	    Q.all = all;
	    function all(promises) {
	        return when(promises, function (promises) {
	            var pendingCount = 0;
	            var deferred = defer();
	            array_reduce(promises, function (undefined, promise, index) {
	                var snapshot;
	                if (isPromise(promise) && (snapshot = promise.inspect()).state === "fulfilled") {
	                    promises[index] = snapshot.value;
	                } else {
	                    ++pendingCount;
	                    when(promise, function (value) {
	                        promises[index] = value;
	                        if (--pendingCount === 0) {
	                            deferred.resolve(promises);
	                        }
	                    }, deferred.reject, function (progress) {
	                        deferred.notify({ index: index, value: progress });
	                    });
	                }
	            }, void 0);
	            if (pendingCount === 0) {
	                deferred.resolve(promises);
	            }
	            return deferred.promise;
	        });
	    }
	
	    Promise.prototype.all = function () {
	        return all(this);
	    };
	
	    Q.any = any;
	
	    function any(promises) {
	        if (promises.length === 0) {
	            return Q.resolve();
	        }
	
	        var deferred = Q.defer();
	        var pendingCount = 0;
	        array_reduce(promises, function (prev, current, index) {
	            var promise = promises[index];
	
	            pendingCount++;
	
	            when(promise, onFulfilled, onRejected, onProgress);
	            function onFulfilled(result) {
	                deferred.resolve(result);
	            }
	            function onRejected(err) {
	                pendingCount--;
	                if (pendingCount === 0) {
	                    err.message = "Q can't get fulfillment value from any promise, all " + "promises were rejected. Last error message: " + err.message;
	                    deferred.reject(err);
	                }
	            }
	            function onProgress(progress) {
	                deferred.notify({
	                    index: index,
	                    value: progress
	                });
	            }
	        }, undefined);
	
	        return deferred.promise;
	    }
	
	    Promise.prototype.any = function () {
	        return any(this);
	    };
	
	    Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
	    function allResolved(promises) {
	        return when(promises, function (promises) {
	            promises = array_map(promises, Q);
	            return when(all(array_map(promises, function (promise) {
	                return when(promise, noop, noop);
	            })), function () {
	                return promises;
	            });
	        });
	    }
	
	    Promise.prototype.allResolved = function () {
	        return allResolved(this);
	    };
	
	    Q.allSettled = allSettled;
	    function allSettled(promises) {
	        return Q(promises).allSettled();
	    }
	
	    Promise.prototype.allSettled = function () {
	        return this.then(function (promises) {
	            return all(array_map(promises, function (promise) {
	                promise = Q(promise);
	                function regardless() {
	                    return promise.inspect();
	                }
	                return promise.then(regardless, regardless);
	            }));
	        });
	    };
	
	    Q.fail = Q["catch"] = function (object, rejected) {
	        return Q(object).then(void 0, rejected);
	    };
	
	    Promise.prototype.fail = Promise.prototype["catch"] = function (rejected) {
	        return this.then(void 0, rejected);
	    };
	
	    Q.progress = progress;
	    function progress(object, progressed) {
	        return Q(object).then(void 0, void 0, progressed);
	    }
	
	    Promise.prototype.progress = function (progressed) {
	        return this.then(void 0, void 0, progressed);
	    };
	
	    Q.fin = Q["finally"] = function (object, callback) {
	        return Q(object)["finally"](callback);
	    };
	
	    Promise.prototype.fin = Promise.prototype["finally"] = function (callback) {
	        if (!callback || typeof callback.apply !== "function") {
	            throw new Error("Q can't apply finally callback");
	        }
	        callback = Q(callback);
	        return this.then(function (value) {
	            return callback.fcall().then(function () {
	                return value;
	            });
	        }, function (reason) {
	            return callback.fcall().then(function () {
	                throw reason;
	            });
	        });
	    };
	
	    Q.done = function (object, fulfilled, rejected, progress) {
	        return Q(object).done(fulfilled, rejected, progress);
	    };
	
	    Promise.prototype.done = function (fulfilled, rejected, progress) {
	        var onUnhandledError = function onUnhandledError(error) {
	            Q.nextTick(function () {
	                makeStackTraceLong(error, promise);
	                if (Q.onerror) {
	                    Q.onerror(error);
	                } else {
	                    throw error;
	                }
	            });
	        };
	
	        var promise = fulfilled || rejected || progress ? this.then(fulfilled, rejected, progress) : this;
	
	        if ((typeof process === "undefined" ? "undefined" : (0, _typeof3.default)(process)) === "object" && process && process.domain) {
	            onUnhandledError = process.domain.bind(onUnhandledError);
	        }
	
	        promise.then(void 0, onUnhandledError);
	    };
	
	    Q.timeout = function (object, ms, error) {
	        return Q(object).timeout(ms, error);
	    };
	
	    Promise.prototype.timeout = function (ms, error) {
	        var deferred = defer();
	        var timeoutId = setTimeout(function () {
	            if (!error || "string" === typeof error) {
	                error = new Error(error || "Timed out after " + ms + " ms");
	                error.code = "ETIMEDOUT";
	            }
	            deferred.reject(error);
	        }, ms);
	
	        this.then(function (value) {
	            clearTimeout(timeoutId);
	            deferred.resolve(value);
	        }, function (exception) {
	            clearTimeout(timeoutId);
	            deferred.reject(exception);
	        }, deferred.notify);
	
	        return deferred.promise;
	    };
	
	    Q.delay = function (object, timeout) {
	        if (timeout === void 0) {
	            timeout = object;
	            object = void 0;
	        }
	        return Q(object).delay(timeout);
	    };
	
	    Promise.prototype.delay = function (timeout) {
	        return this.then(function (value) {
	            var deferred = defer();
	            setTimeout(function () {
	                deferred.resolve(value);
	            }, timeout);
	            return deferred.promise;
	        });
	    };
	
	    Q.nfapply = function (callback, args) {
	        return Q(callback).nfapply(args);
	    };
	
	    Promise.prototype.nfapply = function (args) {
	        var deferred = defer();
	        var nodeArgs = array_slice(args);
	        nodeArgs.push(deferred.makeNodeResolver());
	        this.fapply(nodeArgs).fail(deferred.reject);
	        return deferred.promise;
	    };
	
	    Q.nfcall = function (callback) {
	        var args = array_slice(arguments, 1);
	        return Q(callback).nfapply(args);
	    };
	
	    Promise.prototype.nfcall = function () {
	        var nodeArgs = array_slice(arguments);
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        this.fapply(nodeArgs).fail(deferred.reject);
	        return deferred.promise;
	    };
	
	    Q.nfbind = Q.denodeify = function (callback) {
	        if (callback === undefined) {
	            throw new Error("Q can't wrap an undefined function");
	        }
	        var baseArgs = array_slice(arguments, 1);
	        return function () {
	            var nodeArgs = baseArgs.concat(array_slice(arguments));
	            var deferred = defer();
	            nodeArgs.push(deferred.makeNodeResolver());
	            Q(callback).fapply(nodeArgs).fail(deferred.reject);
	            return deferred.promise;
	        };
	    };
	
	    Promise.prototype.nfbind = Promise.prototype.denodeify = function () {
	        var args = array_slice(arguments);
	        args.unshift(this);
	        return Q.denodeify.apply(void 0, args);
	    };
	
	    Q.nbind = function (callback, thisp) {
	        var baseArgs = array_slice(arguments, 2);
	        return function () {
	            var nodeArgs = baseArgs.concat(array_slice(arguments));
	            var deferred = defer();
	            nodeArgs.push(deferred.makeNodeResolver());
	            function bound() {
	                return callback.apply(thisp, arguments);
	            }
	            Q(bound).fapply(nodeArgs).fail(deferred.reject);
	            return deferred.promise;
	        };
	    };
	
	    Promise.prototype.nbind = function () {
	        var args = array_slice(arguments, 0);
	        args.unshift(this);
	        return Q.nbind.apply(void 0, args);
	    };
	
	    Q.nmapply = Q.npost = function (object, name, args) {
	        return Q(object).npost(name, args);
	    };
	
	    Promise.prototype.nmapply = Promise.prototype.npost = function (name, args) {
	        var nodeArgs = array_slice(args || []);
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	        return deferred.promise;
	    };
	
	    Q.nsend = Q.nmcall = Q.ninvoke = function (object, name) {
	        var nodeArgs = array_slice(arguments, 2);
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	        return deferred.promise;
	    };
	
	    Promise.prototype.nsend = Promise.prototype.nmcall = Promise.prototype.ninvoke = function (name) {
	        var nodeArgs = array_slice(arguments, 1);
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	        return deferred.promise;
	    };
	
	    Q.nodeify = nodeify;
	    function nodeify(object, nodeback) {
	        return Q(object).nodeify(nodeback);
	    }
	
	    Promise.prototype.nodeify = function (nodeback) {
	        if (nodeback) {
	            this.then(function (value) {
	                Q.nextTick(function () {
	                    nodeback(null, value);
	                });
	            }, function (error) {
	                Q.nextTick(function () {
	                    nodeback(error);
	                });
	            });
	        } else {
	            return this;
	        }
	    };
	
	    Q.noConflict = function () {
	        throw new Error("Q.noConflict only works when Q is used as a global");
	    };
	
	    var qEndingLine = captureLine();
	
	    return Q;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187), __webpack_require__(50)(module)))

/***/ },
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (source) {
	  return function (h) {
	
	    var rows = __webpack_require__(308)(h, this);
	    var normalFilter = __webpack_require__(304)(h, this);
	    var dropdownPagination = __webpack_require__(299)(h, this);
	    var columnFilters = __webpack_require__(296)(h, this);
	    var footerHeadings = __webpack_require__(300)(h, this);
	    var noResults = __webpack_require__(303)(h, this);
	    var pagination = __webpack_require__(305)(h, this);
	    var dropdownPaginationCount = __webpack_require__(298)(h, this);
	    var headings = __webpack_require__(301)(h, this);
	    var perPage = __webpack_require__(307)(h, this);
	
	    return h(
	      'div',
	      { 'class': "VueTables VueTables--" + this.source },
	      [h(
	        'div',
	        { 'class': 'row' },
	        [h(
	          'div',
	          { 'class': 'col-md-6' },
	          [normalFilter]
	        ), h(
	          'div',
	          { 'class': 'col-md-6' },
	          [dropdownPagination, perPage]
	        )]
	      ), h(
	        'table',
	        { 'class': 'VueTables__table table ' + this.opts.skin },
	        [h(
	          'thead',
	          null,
	          [h(
	            'tr',
	            null,
	            [headings]
	          ), columnFilters]
	        ), footerHeadings, h(
	          'tbody',
	          null,
	          [noResults, rows]
	        )]
	      ), pagination, dropdownPaginationCount]
	    );
	  };
	};

/***/ },
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(366)
	
	/* script */
	__vue_exports__ = __webpack_require__(222)
	
	/* template */
	var __vue_template__ = __webpack_require__(411)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(368)
	
	/* script */
	__vue_exports__ = __webpack_require__(225)
	
	/* template */
	var __vue_template__ = __webpack_require__(413)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 51,
		"./af.js": 51,
		"./ar": 57,
		"./ar-dz": 52,
		"./ar-dz.js": 52,
		"./ar-ly": 53,
		"./ar-ly.js": 53,
		"./ar-ma": 54,
		"./ar-ma.js": 54,
		"./ar-sa": 55,
		"./ar-sa.js": 55,
		"./ar-tn": 56,
		"./ar-tn.js": 56,
		"./ar.js": 57,
		"./az": 58,
		"./az.js": 58,
		"./be": 59,
		"./be.js": 59,
		"./bg": 60,
		"./bg.js": 60,
		"./bn": 61,
		"./bn.js": 61,
		"./bo": 62,
		"./bo.js": 62,
		"./br": 63,
		"./br.js": 63,
		"./bs": 64,
		"./bs.js": 64,
		"./ca": 65,
		"./ca.js": 65,
		"./cs": 66,
		"./cs.js": 66,
		"./cv": 67,
		"./cv.js": 67,
		"./cy": 68,
		"./cy.js": 68,
		"./da": 69,
		"./da.js": 69,
		"./de": 71,
		"./de-at": 70,
		"./de-at.js": 70,
		"./de.js": 71,
		"./dv": 72,
		"./dv.js": 72,
		"./el": 73,
		"./el.js": 73,
		"./en-au": 74,
		"./en-au.js": 74,
		"./en-ca": 75,
		"./en-ca.js": 75,
		"./en-gb": 76,
		"./en-gb.js": 76,
		"./en-ie": 77,
		"./en-ie.js": 77,
		"./en-nz": 78,
		"./en-nz.js": 78,
		"./eo": 79,
		"./eo.js": 79,
		"./es": 81,
		"./es-do": 80,
		"./es-do.js": 80,
		"./es.js": 81,
		"./et": 82,
		"./et.js": 82,
		"./eu": 83,
		"./eu.js": 83,
		"./fa": 84,
		"./fa.js": 84,
		"./fi": 85,
		"./fi.js": 85,
		"./fo": 86,
		"./fo.js": 86,
		"./fr": 89,
		"./fr-ca": 87,
		"./fr-ca.js": 87,
		"./fr-ch": 88,
		"./fr-ch.js": 88,
		"./fr.js": 89,
		"./fy": 90,
		"./fy.js": 90,
		"./gd": 91,
		"./gd.js": 91,
		"./gl": 92,
		"./gl.js": 92,
		"./he": 93,
		"./he.js": 93,
		"./hi": 94,
		"./hi.js": 94,
		"./hr": 95,
		"./hr.js": 95,
		"./hu": 96,
		"./hu.js": 96,
		"./hy-am": 97,
		"./hy-am.js": 97,
		"./id": 98,
		"./id.js": 98,
		"./is": 99,
		"./is.js": 99,
		"./it": 100,
		"./it.js": 100,
		"./ja": 101,
		"./ja.js": 101,
		"./jv": 102,
		"./jv.js": 102,
		"./ka": 103,
		"./ka.js": 103,
		"./kk": 104,
		"./kk.js": 104,
		"./km": 105,
		"./km.js": 105,
		"./ko": 106,
		"./ko.js": 106,
		"./ky": 107,
		"./ky.js": 107,
		"./lb": 108,
		"./lb.js": 108,
		"./lo": 109,
		"./lo.js": 109,
		"./lt": 110,
		"./lt.js": 110,
		"./lv": 111,
		"./lv.js": 111,
		"./me": 112,
		"./me.js": 112,
		"./mi": 113,
		"./mi.js": 113,
		"./mk": 114,
		"./mk.js": 114,
		"./ml": 115,
		"./ml.js": 115,
		"./mr": 116,
		"./mr.js": 116,
		"./ms": 118,
		"./ms-my": 117,
		"./ms-my.js": 117,
		"./ms.js": 118,
		"./my": 119,
		"./my.js": 119,
		"./nb": 120,
		"./nb.js": 120,
		"./ne": 121,
		"./ne.js": 121,
		"./nl": 123,
		"./nl-be": 122,
		"./nl-be.js": 122,
		"./nl.js": 123,
		"./nn": 124,
		"./nn.js": 124,
		"./pa-in": 125,
		"./pa-in.js": 125,
		"./pl": 126,
		"./pl.js": 126,
		"./pt": 128,
		"./pt-br": 127,
		"./pt-br.js": 127,
		"./pt.js": 128,
		"./ro": 129,
		"./ro.js": 129,
		"./ru": 130,
		"./ru.js": 130,
		"./se": 131,
		"./se.js": 131,
		"./si": 132,
		"./si.js": 132,
		"./sk": 133,
		"./sk.js": 133,
		"./sl": 134,
		"./sl.js": 134,
		"./sq": 135,
		"./sq.js": 135,
		"./sr": 137,
		"./sr-cyrl": 136,
		"./sr-cyrl.js": 136,
		"./sr.js": 137,
		"./ss": 138,
		"./ss.js": 138,
		"./sv": 139,
		"./sv.js": 139,
		"./sw": 140,
		"./sw.js": 140,
		"./ta": 141,
		"./ta.js": 141,
		"./te": 142,
		"./te.js": 142,
		"./tet": 143,
		"./tet.js": 143,
		"./th": 144,
		"./th.js": 144,
		"./tl-ph": 145,
		"./tl-ph.js": 145,
		"./tlh": 146,
		"./tlh.js": 146,
		"./tr": 147,
		"./tr.js": 147,
		"./tzl": 148,
		"./tzl.js": 148,
		"./tzm": 150,
		"./tzm-latn": 149,
		"./tzm-latn.js": 149,
		"./tzm.js": 150,
		"./uk": 151,
		"./uk.js": 151,
		"./uz": 152,
		"./uz.js": 152,
		"./vi": 153,
		"./vi.js": 153,
		"./x-pseudo": 154,
		"./x-pseudo.js": 154,
		"./yo": 155,
		"./yo.js": 155,
		"./zh-cn": 156,
		"./zh-cn.js": 156,
		"./zh-hk": 157,
		"./zh-hk.js": 157,
		"./zh-tw": 158,
		"./zh-tw.js": 158
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 190;


/***/ },
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _AppMenu = __webpack_require__(388);
	
	var _AppMenu2 = _interopRequireDefault(_AppMenu);
	
	var _error = __webpack_require__(400);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _UserActions = __webpack_require__(398);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'app',
		components: {
			AppMenu: _AppMenu2.default,
			UserActions: _UserActions2.default,
			Err: _error2.default
		},
		computed: {
			app: function app() {
				return this.$store.state.app;
			},
			loading: function loading() {
				return this.$store.state.app.loading && !this.$store.state.app.suppressLoading;
			}
		}
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(21);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _AppData = __webpack_require__(7);
	
	var _AppData2 = _interopRequireDefault(_AppData);
	
	var _Toggle = __webpack_require__(188);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _q = __webpack_require__(164);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _vueScrollTo = __webpack_require__(424);
	
	var _vueScrollTo2 = _interopRequireDefault(_vueScrollTo);
	
	var _Router = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueScrollTo2.default);
	
	var bus = new _vue2.default();
	
	var rowMapper = function rowMapper(row) {
		return {
			'extCompRef': row.extCompRef,
			'Mapped Location/Node': row.description,
			'Location/Node ID': row.nodeid,
			'data': row
		};
	};
	
	var removeTemplate = function removeTemplate(h, row) {
		return h('remove-mapping', {
			attrs: {
				'row': row.data
			}
		});
	};
	
	var troubleshootTemplate = function troubleshootTemplate(h, row) {
		return h('troubleshoot-mapping', {
			attrs: {
				'row': {
					extCompRef: row.data.extCompRef,
					storeId: row.data.nodeid
				}
			}
		});
	};
	
	_vue2.default.component('remove-mapping', {
		props: ['row'],
		template: '<button v-on:click="emitRemove"><i class="fa fa-times" aria-hidden="true"></i> Remove</button>',
		methods: {
			emitRemove: function emitRemove(e) {
				bus.$emit('remove', this.row);
				e.preventDefault();
			}
		}
	});
	
	_vue2.default.component('troubleshoot-mapping', {
		props: ['row'],
		template: '<button v-on:click="emitTroubleshoot"><i class="fa fa-building-o" aria-hidden="true"></i> Troubleshoot</button>',
		methods: {
			emitTroubleshoot: function emitTroubleshoot(e) {
				bus.$emit('troubleshoot', this.row);
				e.preventDefault();
			}
		}
	});
	
	exports.default = {
		name: 'AcademyDetails',
		components: {
			'job-config': __webpack_require__(390),
			'pay-config': __webpack_require__(394),
			'exclude-jobs': __webpack_require__(401),
			Toggle: _Toggle2.default
		},
		data: function data() {
			return {
				columns: ['Mapped Location/Node', 'Location/Node ID', 'extCompRef', 'Action', 'Troubleshoot'],
				options: {
					perPage: 100,
					filterable: false,
					templates: {
						'Action': removeTemplate,
						'Troubleshoot': troubleshootTemplate
					}
				},
				delayMin: 1,
				delayMax: 60,
				editIgnores: false,
				ignoreToAdd: '',
				confirm: {
					enabled: false,
					action: null,
					msg: null
				},
				progress: {
					percent: 20,
					msg: 'Loading user data from HotSchedules',
					active: false,
					tempStep: 0,
					temp: [{ percent: 0, t: 300, msg: 'Loading user data from HotSchedules' }, { percent: 15, t: 600, msg: 'some message 1' }, { percent: 27, t: 800, msg: 'some message 2' }, { percent: 63, t: 700, msg: 'some message 3' }, { percent: 90, t: 300, msg: 'some message 4 almost finished' }]
				},
				jobEditor: {
					jobs: [],
					name: '',
					index: null
				},
				paytype: {
					editing: false
				}
			};
		},
	
		computed: {
			valid: function valid() {
				var id = parseInt(this.$route.params.id);
				return !_underscore2.default.isUndefined(_underscore2.default.findWhere(this.$store.state.academiesList, { id: id }));
			},
			academy: function academy() {
				var id = parseInt(this.$route.params.id);
				return _underscore2.default.findWhere(this.$store.state.academiesList, { id: id });
			},
			tableData: function tableData() {
				return _underscore2.default.map(this.academy.mappings, rowMapper);
			},
			jobsmap: function jobsmap() {
				var js = this.$store.state.config.swapJobs;
	
				if (!js || !js.action) {
					return [];
				}
	
				return this.$store.state.config.swapJobs.jobSwapper.jobsmap;
			},
			jobsmapReady: function jobsmapReady() {
				return this.$store.state.jobswap.ready;
			},
			jobsmapMessage: function jobsmapMessage() {
				return this.$store.state.jobswap.msg;
			},
			paytypeJobsReady: function paytypeJobsReady() {
				return this.$store.state.paytype.ready;
			},
			paytypeJobsMessage: function paytypeJobsMessage() {
				return this.$store.state.paytype.msg;
			},
			availableJobs: function availableJobs() {
				var usedNames = _underscore2.default.chain(this.jobsmap).map(function (row) {
					var names = _underscore2.default.clone(row.hsNames);
					names.push(row.scxJobName);
					return names;
				}).flatten().value();
	
				return _underscore2.default.difference(this.$store.state.jobswap.list, usedNames);
			},
			syncedJobs: function syncedJobs() {
				return _underscore2.default.difference(this.$store.state.jobswap.list, this.$store.state.config.excludeJobs);
			},
			exludedJobs: function exludedJobs() {
				return this.$store.state.config.excludeJobs;
			},
			hridSync: function hridSync() {
				return this.$store.state.config.hridSync;
			},
			ascUserSync: function ascUserSync() {
				return this.$store.state.config.ascSync;
			},
			hridPush: function hridPush() {
				return this.$store.state.config.hridPush;
			},
			ignores: function ignores() {
				return this.$store.state.config.ignores;
			},
			delay: function delay() {
				return this.$store.state.config.delay;
			},
			days: function days() {
				return this.$store.state.config.delay.days;
			},
			hourly: function hourly() {
				return this.$store.state.config.hourly;
			},
			salary: function salary() {
				return _underscore2.default.difference(this.$store.state.paytype.list, this.$store.state.config.hourly);
			},
			status: function status() {
				return this.$store.state.status;
			},
			isSyncing: function isSyncing() {
				return this.$store.state.status.status === 'Syncing';
			},
			working: function working() {
				return !this.$store.state.jobswap.ready || !this.$store.state.paytype.ready || this.$store.state.status.status === 'Syncing';
			}
		},
		methods: {
			confirmSync: function confirmSync() {
				var _this = this;
	
				this.toConfirm('Confirm start sync', function () {
					_this.syncNow();
				});
			},
			syncNow: function syncNow() {
				var _this2 = this;
	
				this.$store.dispatch('sync', this.$route.params.id);
				this.stopSyncPoll = this.$watch(function () {
					return _this2.$store.state.sync.count;
				}, function () {
					return _this2.pollSync();
				});
			},
			toConfirm: function toConfirm(msg, action) {
				this.confirm.action = action;
				this.confirm.msg = msg;
				this.confirm.enabled = true;
			},
			onConfirm: function onConfirm() {
				if (this.confirm.action) {
					this.confirm.action();
				}
				this.confirm.enabled = false;
			},
			getActionLabel: function getActionLabel(b) {
				return b ? 'disable' : 'enable';
			},
			confirmToggleHRID: function confirmToggleHRID() {
				var _this3 = this;
	
				this.toConfirm('Confirm ' + this.getActionLabel(this.hridSync) + ' HRID sync', function () {
					_this3.$store.dispatch('setHRIDsync', {
						id: _this3.academy.id,
						action: !_this3.hridSync
					});
				});
			},
			confirmToggleASC: function confirmToggleASC() {
				var _this4 = this;
	
				this.toConfirm('Confirm ' + this.getActionLabel(this.ascUserSync) + ' ASC user sync', function () {
					_this4.$store.dispatch('setASCsync', {
						id: _this4.academy.id,
						action: !_this4.ascUserSync
					});
				});
			},
			confirmPushHRID: function confirmPushHRID() {
				var _this5 = this;
	
				this.toConfirm('Confirm ' + this.getActionLabel(this.hridPush) + ' Push HRIDs to Schoox', function () {
					_this5.$store.dispatch('setHRIDpush', {
						id: _this5.academy.id,
						action: !_this5.hridPush
					});
				});
			},
			confirmRemoveMapping: function confirmRemoveMapping(toRemove) {
				var _this6 = this;
	
				this.toConfirm('Confirm remove mapping.<br>This action cannot be undone.', function () {
					_this6.$store.dispatch('removeMapping', {
						acadid: _this6.academy.id,
						mapping: toRemove
					});
				});
			},
			confirmRemoveAll: function confirmRemoveAll() {
				var _this7 = this;
	
				this.toConfirm('Confirm remove all mappings for ' + this.academy.name + '<br>This action cannot be undone.', function () {
					_this7.$store.dispatch('removeAllMappings', {
						acadid: _this7.academy.id
					});
				});
			},
			confirmDelayRemove: function confirmDelayRemove() {
				var _this8 = this;
	
				var obj = {
					id: this.academy.id,
					action: !this.delay.action,
					days: this.delay.days
				};
				this.toConfirm('Confirm ' + this.getActionLabel(this.delay.action) + ' delay removal', function () {
					return _this8.$store.dispatch('setDelayRemoval', obj);
				});
			},
			saveDelayDays: function saveDelayDays(e) {
				var n = parseInt(e.target.value);
				if (_underscore2.default.isNumber(n) && n !== this.delay.days) {
					this.$store.dispatch('setDelayRemoval', {
						id: this.academy.id,
						action: this.delay.action,
						days: n
					});
				}
			},
			addIgnore: function addIgnore(e) {
				if (_underscore2.default.isEmpty(this.ignoreToAdd)) {
					return;
				}
				this.$store.dispatch('addIgnores', {
					id: this.academy.id,
					ignores: this.ignoreToAdd.split(/,\s*/)
				});
				this.ignoreToAdd = null;
				e.preventDefault();
			},
			removeIgnore: function removeIgnore(ignore) {
				this.$store.dispatch('removeIgnore', {
					id: this.academy.id,
					ignore: ignore
				});
			},
			editJobMapping: function editJobMapping(index) {
				var _this9 = this;
	
				if (this.$store.state.jobswap.list === 'performing first calculation') {
					_AppData2.default.dispatch('getJobsList', parseInt(this.$route.params.id));
				}
	
				if (_underscore2.default.isNumber(this.jobEditor.index)) {
					this.jobEditor.index = null;
					_underscore2.default.delay(function () {
						_this9.jobEditor.index = index;
					}, 100);
				} else {
					this.jobEditor.index = index;
				}
			},
			updatePayType: function updatePayType(data) {
				this.$store.dispatch('updatePayType', {
					id: this.academy.id,
					hourly: data
				});
			},
			updateExcludedJobs: function updateExcludedJobs(data) {
				this.$store.dispatch('updateExcluded', {
					id: this.academy.id,
					excludeJobs: data
				});
			},
			scroll: function scroll(el) {
				_vueScrollTo2.default.scrollTo(el, 300, {
					easing: _vueScrollTo2.default.easing['ease-in']
				});
			},
			confirmJobNameRemove: function confirmJobNameRemove(index) {
				var _this10 = this;
	
				this.toConfirm('Confirm remove job name mapping', function () {
					var mappings = JSON.parse((0, _stringify2.default)(_this10.$store.state.config.swapJobs));
	
					mappings.jobSwapper.jobsmap.splice(index, 1);
	
					_this10.$store.dispatch('updateJobsList', {
						id: _this10.academy.id,
						mappings: mappings
					});
				});
			},
			getRestrictedNames: function getRestrictedNames(allow) {
				return _underscore2.default.chain(this.jobsmap).pluck('scxJobName').without(allow).value();
			},
			finishJobNameEdit: function finishJobNameEdit(index, row) {
				var mappings = JSON.parse((0, _stringify2.default)(this.$store.state.config.swapJobs));
	
				mappings.action = true;
	
				if (!mappings.jobSwapper) {
					mappings.jobSwapper = {
						jobsmap: []
					};
				}
				if (!mappings.jobSwapper.jobsmap[index]) {
					mappings.jobSwapper.jobsmap.push(row);
				} else {
					mappings.jobSwapper.jobsmap.splice(index, 1, row);
				}
	
				this.$store.dispatch('updateJobsList', {
					id: this.academy.id,
					mappings: mappings
				});
				this.jobEditor.index = null;
			},
			cancelJobMapEdit: function cancelJobMapEdit() {
				this.jobEditor.index = null;
			},
			pollJobsMap: function pollJobsMap() {
				var _this11 = this;
	
				if (this.$store.state.jobswap.ready) {
					this.stopJobsPoll();
				} else {
					this.pollJobsTimer = _underscore2.default.delay(function () {
						return _AppData2.default.dispatch('getJobsList', _this11.$route.params.id);
					}, 1000);
				}
			},
			pollPayJobs: function pollPayJobs() {
				var _this12 = this;
	
				if (this.$store.state.paytype.ready) {
					this.stopPayPoll();
				} else {
					this.pollPayTimer = _underscore2.default.delay(function () {
						return _AppData2.default.dispatch('getJobPaytypes', _this12.$route.params.id);
					}, 1000);
				}
			},
			pollSync: function pollSync() {
				var _this13 = this;
	
				if (this.$store.state.sync.syncAvailable || _underscore2.default.isUndefined(this.$route.params.id)) {
					this.stopSyncPoll();
				} else {
					this.syncPollTimer = _underscore2.default.delay(function () {
						return _AppData2.default.dispatch('getStatus', _this13.$route.params.id);
					}, 1000);
				}
			},
			troubleshoot: function troubleshoot(row) {
				_Router.router.push({
					name: 'troubleshootingloc',
					params: row
				});
			}
		},
		created: function created() {
			bus.$on('remove', this.confirmRemoveMapping);
			bus.$on('troubleshoot', this.troubleshoot);
		},
		beforeRouteEnter: function beforeRouteEnter(to, from, next) {
			var loads = [];
			if (!_AppData2.default.state.academiesLoaded) {
				loads.push(_AppData2.default.dispatch('getAcademies'));
			}
			_q2.default.all(loads).then(function () {
				return next();
			});
		},
		beforeMount: function beforeMount() {
			var _this14 = this;
	
			_AppData2.default.dispatch('getAcademyConfig', this.$route.params.id);
			this.stopSyncPoll = this.$watch(function () {
				return _this14.$store.state.sync.count;
			}, function () {
				return _this14.pollSync();
			});
		},
		mounted: function mounted() {
			var _this15 = this;
	
			if (!this.$store.state.jobswap.ready) {
				this.stopJobsPoll = this.$watch(function () {
					return _this15.$store.state.jobswap.pollCount;
				}, function () {
					return _this15.pollJobsMap();
				});
				this.pollJobsMap();
			}
			if (!this.$store.state.paytype.ready) {
				this.stopPayPoll = this.$watch(function () {
					return _this15.$store.state.paytype.pollCount;
				}, function () {
					return _this15.pollPayJobs();
				});
				this.pollPayJobs();
			}
	
			_AppData2.default.dispatch('getStatus', this.$route.params.id);
		},
		beforeDestroy: function beforeDestroy() {
			clearTimeout(this.pollJobsTimer);
			clearTimeout(this.pollPayTimer);
			clearTimeout(this.syncPollTimer);
	
			if (_underscore2.default.isFunction(this.stopJobsPoll)) {
				this.stopJobsPoll();
			}
			if (_underscore2.default.isFunction(this.stopPayPoll)) {
				this.stopPayPoll();
			}
			if (_underscore2.default.isFunction(this.stopSyncPoll)) {
				this.stopSyncPoll();
			}
	
			this.$store.dispatch('clearJobs');
		}
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _AppData = __webpack_require__(7);
	
	var _AppData2 = _interopRequireDefault(_AppData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowMapper = function rowMapper(row) {
		return {
			'Academy ID': row.acadid,
			'Academy Name': row.acadname,
			'Customer': row.company,
			'Last HRID Sync': row.lastrun,
			'extCompRef': row.extCompRef,
			'Location/Node': row.description,
			'HRID sync': 'ON',
			'ASC user sync': 'ON',
			'Location/Node ID': row.nodeid
		};
	};
	
	exports.default = {
		name: 'academysearch',
		data: function data() {
			return {
				extCompRef: null,
				acadid: null,
				err: null,
				results: [],
				searched: false,
				columns: ['extCompRef', 'Academy ID', 'Academy Name', 'Customer', 'Location/Node', 'Location/Node ID', 'HRID sync', 'ASC user sync', 'Last HRID Sync', 'Details'],
				options: {
					perPage: 25,
					templates: {
						'Details': function Details(h, row) {
							return h('details-link', { attrs: { 'id': row['Academy ID'] } });
						}
					},
					filterable: false
				}
			};
		},
	
		computed: {
			resultsCount: function resultsCount() {
				return this.results.length;
			},
			tableData: function tableData() {
				return _underscore2.default.map(this.results, rowMapper);
			}
		},
		methods: {
			search: function search() {
				var query = {};
				this.err = null;
	
				if (!_underscore2.default.isEmpty(this.extCompRef)) {
					query.extCompRef = this.extCompRef;
				}
				if (!_underscore2.default.isEmpty(this.acadid)) {
					query.acadid = parseInt(this.acadid);
				}
	
				if (_underscore2.default.isEmpty(query)) {
					this.err = 'You must enter a Academy Id or a extCompRef';
				} else {
					this.results = _underscore2.default.where(this.$store.state.academies, query);
					this.searched = true;
				}
			}
		},
		beforeRouteEnter: function beforeRouteEnter(to, from, next) {
			if (_AppData2.default.state.academiesLoaded) return next();
			_AppData2.default.dispatch('getAcademies').then(function (res) {
				return next();
			});
		}
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _AppData = __webpack_require__(7);
	
	var _AppData2 = _interopRequireDefault(_AppData);
	
	var _vueInfiniteScroll = __webpack_require__(383);
	
	var _vueInfiniteScroll2 = _interopRequireDefault(_vueInfiniteScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueInfiniteScroll2.default);
	
	exports.default = {
		name: 'activity-log',
	
		computed: {
			logdata: function logdata() {
				return this.$store.state.activity.log;
			},
			filter: function filter() {
				return this.$store.state.activity.filter;
			},
			loading: function loading() {
				return this.$store.state.app.loading;
			},
			end: function end() {
				return this.$store.state.activity.end;
			}
		},
		methods: {
			loadMore: function loadMore() {
				if (!this.end) {
					_AppData2.default.dispatch('getLogEntries', this);
				}
			},
			updateFilter: function updateFilter(e) {
				this.$validator.validateAll();
				var filter = e.target.value;
				if (!this.errors.any() && this.$store.state.activity.filter !== filter) {
					_AppData2.default.dispatch('setActivityFilter', filter);
					_AppData2.default.dispatch('getLogEntries', this);
				}
			}
		},
		beforeRouteEnter: function beforeRouteEnter(to, from, next) {
			if (_AppData2.default.state.activity.log.length) return next();
			_AppData2.default.dispatch('getLogEntries', this).then(function (res) {
				return next();
			});
		},
		beforeMount: function beforeMount() {
			_AppData2.default.commit('setSuppressLoading', true);
		},
		beforeDestroy: function beforeDestroy() {
			_AppData2.default.commit('setSuppressLoading', false);
		}
	};

/***/ },
/* 214 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'appmenu',
		data: function data() {
			return {
				items: [{ title: 'Academy Mappings', icon: 'list', path: '/list' }, { title: 'Academy Search', icon: 'search', path: '/search' }, { title: 'New Mapping', icon: 'map', path: '/mapping' }, { title: 'Troubleshooting', icon: 'address-card', path: '/troubleshooting' }, { title: 'Activity Log', icon: 'book', path: '/log' }]
			};
		},
	
		computed: {
			loggedIn: function loggedIn() {
				return this.$store.state.user.authenticated;
			}
		}
	};

/***/ },
/* 215 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuedraggable = __webpack_require__(49);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _veeValidate = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options = {
		available: {
			group: {
				name: 'jobs',
				put: true,
				clone: false
			},
			sort: false
		},
		hs: {
			group: {
				name: 'jobs',
				put: true,
				clone: false
			},
			sort: true
		}
	};
	
	var props = {
		'available': {
			type: Array,
			default: []
		},
		'toName': {
			type: String,
			default: ''
		},
		'hsNames': {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		'restricted': {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		'index': {
			type: Number,
			required: true
		}
	};
	
	exports.default = {
		props: props,
		components: { draggable: _vuedraggable2.default },
		name: 'job-config',
		data: function data() {
			return {
				hsNameCount: 0,
				name: ''
			};
		},
	
		computed: {
			hsOptions: function hsOptions() {
				return options.hs;
			},
			availableOptions: function availableOptions() {
				return options.available;
			}
		},
		methods: {
			cancel: function cancel() {
				window.location.reload();
			},
			finish: function finish() {
				this.$validator.validateAll();
				if (!this.errors.any()) {
					this.$emit('finish', this.index, {
						scxJobName: this.name,
						hsNames: this.hsNames
					});
				}
			},
			setAvailableJobs: function setAvailableJobs() {
				var usedNames = _underscore2.default.chain(this.rows).map(function (row) {
					var names = _underscore2.default.clone(row.hsNames);
					names.push(row.scxJobName);
					return names;
				}).flatten().value();
	
				this.editor.available = _underscore2.default.difference(this.$store.state.jobswap.list, usedNames);
			},
			updateHsNameCount: function updateHsNameCount() {
				this.hsNameCount = this.hsNames.length;
			}
		},
		created: function created() {
			this.name = this.toName;
		},
		beforeMount: function beforeMount() {
			var _this = this;
	
			_veeValidate.Validator.updateDictionary({
				en: { attributes: { toName: 'Schoox Job Name' } }
			});
			_veeValidate.Validator.extend('uniqueJobName', {
				getMessage: function getMessage(field) {
					return 'The schoox job name must be unique';
				},
				validate: function validate(value) {
					return _underscore2.default.indexOf(_this.restricted, value) === -1;
				}
			});
			_veeValidate.Validator.extend('notEmptyList', {
				getMessage: function getMessage(field) {
					return 'You must select at least one Hot Schedules Job Name';
				},
				validate: function validate(value) {
					return value > 0;
				}
			});
		},
		mounted: function mounted() {
			this.updateHsNameCount();
			this.$emit('ready', this.$el);
		},
		beforeDestroy: function beforeDestroy() {
			_veeValidate.Validator.remove('uniqueJobName');
			_veeValidate.Validator.remove('notEmptyList');
		}
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _AppData = __webpack_require__(7);
	
	var _AppData2 = _interopRequireDefault(_AppData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowMapper = function rowMapper(row) {
		return {
			'Mappings': row.mappings.length,
			'Academy ID': row.id,
			'Academy Name': row.name,
			'Customer': row.company
		};
	};
	
	exports.default = {
		data: function data() {
			return {
				columns: ['Customer', 'Academy ID', 'Academy Name', 'Mappings', 'Details'],
				options: {
					perPage: 25,
					templates: {
						'Details': function Details(h, row) {
							return h('details-link', { attrs: { 'id': row['Academy ID'] } });
						}
					}
				}
			};
		},
	
		computed: {
			tableData: function tableData() {
				return _underscore2.default.map(this.$store.state.academiesList, rowMapper);
			}
		},
		beforeRouteEnter: function beforeRouteEnter(to, from, next) {
			if (_AppData2.default.state.academiesLoaded) return next();
			_AppData2.default.dispatch('getAcademies').then(function (res) {
				return next();
			});
		}
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _auth = __webpack_require__(20);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		id: 'login',
		data: function data() {
			return {
				password: '',
				email: '',
				formSubmitted: false
			};
		},
	
		methods: {
			validateBeforeSubmit: function validateBeforeSubmit(e) {
				this.$validator.validateAll();
				if (!this.errors.any()) {
					this.submitForm();
				}
			},
	
			submitForm: function submitForm() {
				this.formSubmitted = true;
				var credentials = {
					un: this.email,
					pw: this.password
				};
	
				_auth2.default.login(this, credentials, 'home');
			}
		},
		computed: {
			loading: function loading() {
				return this.$store.state.app.loading;
			}
		}
	};

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _ProgressStepper = __webpack_require__(395);
	
	var _ProgressStepper2 = _interopRequireDefault(_ProgressStepper);
	
	var _veeValidate = __webpack_require__(48);
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: { ProgressStepper: _ProgressStepper2.default },
		name: 'mapping-tool',
		data: function data() {
			return {
				acadid: '',
				extCompRef: '',
				nodeid: '',
				nodeloc: 'All',
				location: null,
				steps: ['Search Academy', 'Enter extCompRef', 'Select Location', 'Confirm Mapping']
			};
		},
	
		computed: {
			academy: function academy() {
				return this.$store.state.mapping.academy;
			},
			acadName: function acadName() {
				return 'TODO get name';
			},
			clientid: function clientid() {
				return this.nodeloc === 'All' ? 'all' : this.nodeid;
			},
			acaderror: function acaderror() {
				if (this.errors.has('acadid')) {
					return this.errors.first('acadid');
				}
				if (this.$store.state.mapping.error) {
					return this.$store.state.mapping.error;
				}
				return;
			},
			ecrerror: function ecrerror() {
				if (this.errors.has('extCompRef')) {
					return this.errors.first('extCompRef');
				}
				if (this.$store.state.mapping.error) {
					return this.$store.state.mapping.error;
				}
				return;
			},
			locations: function locations() {
				return this.$store.state.mapping.ecr.nodes;
			},
	
			location: {
				get: function get() {
					return this.$store.state.mapping.location;
				},
				set: function set(loc) {
					this.$store.commit('setNewMappingLocation', loc);
				}
			},
			ecr: function ecr() {
				return this.$store.state.mapping.ecr;
			},
			currentStep: function currentStep() {
				return this.$store.state.mapping.step;
			},
			completed: function completed() {
				return this.$store.state.mapping.completed;
			}
		},
		methods: {
			seachAcademy: function seachAcademy(e) {
				e.preventDefault();
				this.$validator.validateAll();
				if (!this.errors.has('acadid')) {
					this.$store.dispatch('acadLookup', this.acadid);
				}
			},
			confirmCreateMapping: function confirmCreateMapping(e) {
				this.$store.dispatch('createNewMapping', {
					extCompRef: this.ecr.extCompRef,
					company: this.ecr.company,
					description: this.location.description,
					nodeid: this.location.nodeid,
					acadid: this.academy.acadid,
					acadname: this.academy.acadName
				});
			},
			submitExtCompRef: function submitExtCompRef(e) {
				e.preventDefault();
				this.$validator.validateAll();
				if (!this.errors.has('extCompRef')) {
					this.$store.dispatch('getExtCompRef', this.extCompRef);
				}
			},
			submitLocation: function submitLocation(e) {
				e.preventDefault();
				this.$store.commit('setNewMappingStep', 3);
			},
			reset: function reset() {
				this.acadid = '';
				this.extCompRef = '';
				this.$store.commit('clearNewMappingData');
			}
		},
		beforeMount: function beforeMount() {
			this.$store.commit('clearNewMappingData');
			if (this.$route.params.acadid) {
				var id = this.acadid = this.$route.params.acadid;
				var acad = _underscore2.default.findWhere(this.$store.state.academiesList, { id: id });
				this.$store.commit('setAcademyInfo', {
					acadid: id,
					acadName: acad.name
				});
				this.$store.commit('setNewMappingStep', 1);
			} else {
				this.reset();
			}
	
			_veeValidate.Validator.updateDictionary({
				en: { attributes: {
						toName: 'Schoox Job Name',
						nodeid: 'Location/Node ID',
						nodeloc: 'Mapped Location/Node'
					} }
			});
		}
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vuedraggable = __webpack_require__(49);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: {
			'salary': {
				type: Array,
				default: function _default() {
					return [];
				}
			},
			'hourly': {
				type: Array,
				default: function _default() {
					return [];
				}
			}
		},
		components: { draggable: _vuedraggable2.default },
		computed: {
			options: function options() {
				return {
					group: {
						name: 'pay',
						put: true,
						clone: false
					},
					sort: false
				};
			}
		},
		methods: {
			cancel: function cancel() {
				this.$emit('cancel');
			},
			finish: function finish() {
				this.$emit('finish', {});
			},
			update: function update() {
				this.$emit('update', this.hourly);
			}
		}
	
	};

/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: ['steps', 'currentStep']
	};

/***/ },
/* 222 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	
	var props = {
		value: {
			type: Boolean,
			default: false
		},
		confirm: {
			type: Boolean,
			default: false
		},
		labelOn: {
			type: String,
			default: 'on'
		},
		labelOff: {
			type: String,
			default: 'off'
		}
	};
	
	exports.default = {
		props: props,
		methods: {
			change: function change() {
				this.$emit('change', this.value);
			}
		}
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(21);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Toggle = __webpack_require__(188);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _TroubleshootingMenu = __webpack_require__(189);
	
	var _TroubleshootingMenu2 = _interopRequireDefault(_TroubleshootingMenu);
	
	var _api = __webpack_require__(29);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bus = new _vue2.default();
	
	var detailsTemplate = function detailsTemplate(h, row) {
		return h('user-detail-button', {
			attrs: {
				'index': row['index']
			}
		});
	};
	var mapuser = function mapuser(user, i) {
		return {
			'Schoox User Name': user.schooxUserName,
			'Schoox Id': user.schooxId,
			'Hrid': user.hrid,
			'HS User Name': user.hsUserName,
			'HS User Email': user.hsUserEmail,
			'HS Ids': _underscore2.default.isArray(user.hsIds) ? user.hsIds.join(', ') : user.hsIds,
			'HS User Count': user.hsUserCount,
			'Action Count': user.actionCount,
			'Mismatched Name': user.mismatchedName ? 'true' : '',
			'Locations': user.locations,
			'index': i
		};
	};
	
	_vue2.default.component('user-detail-button', {
		props: ['index'],
		template: '<button v-on:click="showDetails">View</button>',
		methods: {
			showDetails: function showDetails(e) {
				bus.$emit('details', this.index);
				e.preventDefault();
			}
		}
	});
	
	exports.default = {
		name: 'Troubleshooting',
		components: {
			'user-details': __webpack_require__(399),
			TroubleshootingMenu: _TroubleshootingMenu2.default,
			Toggle: _Toggle2.default
		},
		data: function data() {
			return {
				acadid: '',
				showRaw: false,
				columns: ['Schoox User Name', 'Schoox Id', 'Hrid', 'HS User Name', 'HS User Email', 'HS Ids', 'Locations', 'HS User Count', 'Action Count', 'Mismatched Name', 'Details'],
				options: {
					perPage: 25,
					templates: {
						'Details': detailsTemplate
					}
				},
				detaillUserIndex: null,
				showUserDetail: false
			};
		},
	
		computed: {
			waitmsg: function waitmsg() {
				return this.$store.state.usermappings.msg;
			},
			searching: function searching() {
				return this.$store.state.troubleshooting.searching;
			},
			resultsFor: function resultsFor() {
				var s = '';
				if (!_underscore2.default.isEmpty(this.hsid)) {
					s += ' HotSchedules id: ' + this.hsid;
				}
				if (!_underscore2.default.isEmpty(this.schooxid)) {
					s += ' Schoox id: ' + this.schooxid;
				}
				return s;
			},
			mappings: function mappings() {
				return this.$store.state.usermappings.data;
			},
			rawData: function rawData() {
				var data = this.detaillUser ? this.detaillUser : this.$store.state.usermappings.data;
				return (0, _stringify2.default)(data, undefined, 2);
			},
			mappingsReady: function mappingsReady() {
				return this.$store.state.usermappings.data && this.$store.state.usermappings.data.length;
			},
			noMappings: function noMappings() {
				return this.$store.state.usermappings.ready && this.$store.state.usermappings.data && !this.$store.state.usermappings.data.length;
			},
			detaillUser: function detaillUser() {
				var u = this.$store.state.usermappings.details;
				return _underscore2.default.isArray(u) ? u[0] : u;
			},
			showList: function showList() {
				return !_underscore2.default.isNull(this.detaillUserIndex);
			},
			report: function report() {
				return '/academy/' + this.acadid + '/mismatchedNames.csv';
			},
			rows: function rows() {
				return _underscore2.default.map(this.$store.state.usermappings.data, mapuser);
			},
			zombies: function zombies() {
				var data = this.$store.state.usermappings.data;
	
				if (!data || !data.length) return 0;
	
				return _underscore2.default.filter(this.$store.state.usermappings.data, function (row) {
					return row.hsUserCount < 1;
				}).length;
			},
			mmCount: function mmCount() {
				var data = this.$store.state.usermappings.data;
	
				if (!data || !data.length) return 0;
	
				return _underscore2.default.filter(this.$store.state.usermappings.data, function (row) {
					return row.mismatchedName === true;
				}).length;
			}
		},
		methods: {
			search: function search() {
				var _this = this;
	
				this.$validator.validateAll();
	
				if (!this.errors.any()) {
					this.stopPoll = this.$watch(function () {
						return _this.$store.state.usermappings.pollCount;
					}, function () {
						return _this.pollData();
					});
					this.$store.dispatch('getUserMappings', { id: this.acadid });
				}
			},
			showDetails: function showDetails(i) {
				console.log('Select user', this.getSchooxId(i));
	
				this.$store.dispatch('getUserDetails', {
					acadid: this.acadid,
					schooxid: this.getSchooxId(i),
					hsids: this.getHsIds(i)
				});
			},
			pollData: function pollData() {
				var _this2 = this;
	
				if (this.$store.state.usermappings.ready) {
					this.stopPoll();
				} else {
					this.pollTimer = _underscore2.default.delay(function () {
						return _this2.$store.dispatch('getUserMappings', { id: _this2.acadid });
					}, 1000);
				}
			},
			getReport: function getReport() {
				return _api2.default.getMissMatchReport(this.acadid);
			},
			getSchooxId: function getSchooxId(i) {
				return this.$store.state.usermappings.data[i].schooxId;
			},
			getHsIds: function getHsIds(i) {
				return this.$store.state.usermappings.data[i].hsIds;
			},
			clearDetails: function clearDetails() {
				this.$store.dispatch('clearUserDetails');
			}
		},
		created: function created() {
			bus.$on('details', this.showDetails);
		},
		beforeMount: function beforeMount() {
			if (this.$route.params.acadid) {
				this.acadid = this.$route.params.acadid;
				this.search();
			}
		},
		beforeDestroy: function beforeDestroy() {
			clearTimeout(this.pollTimer);
			if (_underscore2.default.isFunction(this.stopPoll)) {
				this.stopPoll();
			}
			this.$store.dispatch('clearUserMappings');
		}
	};

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _TroubleshootingMenu = __webpack_require__(189);
	
	var _TroubleshootingMenu2 = _interopRequireDefault(_TroubleshootingMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			TroubleshootingMenu: _TroubleshootingMenu2.default
		},
		data: function data() {
			return {
				extCompRef: '',
				storeId: '',
				waitmsg: 'This may take a moment.'
			};
		},
	
		computed: {
			res: function res() {
				console.log('this.$store.state.hierarchy', this.$store.state.hierarchy);
				return this.$store.state.hierarchy.store;
			},
			resid: function resid() {
				return this.res.id;
			},
			resdesc: function resdesc() {
				return this.res.description;
			},
			err: function err() {
				return this.$store.state.hierarchy.err;
			}
		},
		methods: {
			search: function search() {
				this.$validator.validateAll();
	
				if (!this.errors.any()) {
					this.$store.dispatch('getHierarchyStore', { extCompRef: this.extCompRef, storeId: this.storeId });
				}
			}
		},
		beforeMount: function beforeMount() {
			if (this.$route.params.extCompRef && this.$route.params.storeId) {
				this.extCompRef = this.$route.params.extCompRef;
				this.storeId = this.$route.params.storeId;
				this.search();
			}
		},
		beforeDestroy: function beforeDestroy() {
			this.$store.dispatch('clearHierarchyStore');
		}
	};

/***/ },
/* 225 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: {
			'tab': {
				type: String,
				default: ''
			}
		},
		computed: {
			user: function user() {
				console.log('TAB', this.tab);
				return this.tab === 'user';
			},
			location: function location() {
				return this.tab === 'location';
			}
		}
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _auth = __webpack_require__(20);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		computed: {
			loggedIn: function loggedIn() {
				return this.$store.state.user.authenticated;
			},
			username: function username() {
				return this.$store.state.user.name;
			}
		},
		methods: {
			logout: function logout(e) {
				e.preventDefault();
				_auth2.default.logout();
			}
		}
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var blankUser = {
		email: '',
		schooxLocations: [],
		acadMembers: [],
		lastName: 'No Schoox User Record',
		firstName: '',
		id: '',
		ssoUsers: []
	};
	
	exports.default = {
		name: 'UserDetails',
		props: {
			user: {
				type: Object
			},
			acadid: {}
		},
		data: function data() {
			return {
				confirm: {
					enabled: false,
					action: null,
					msg: null
				}
			};
		},
	
		computed: {
			su: function su() {
				return this.user.schooxUser || blankUser;
			},
			suName: function suName() {
				return this.getUserName(this.su);
			},
			acadMembers: function acadMembers() {
				return this.user.schooxUser.acadMembers;
			}
		},
		methods: {
			getJobs: function getJobs(jobs) {
				return _underscore2.default.map(jobs, function (j) {
					return '<div>' + j.name + '</div>';
				}).join('');
			},
			getUserName: function getUserName() {
				var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
				if (!user) {
					return 'NONE';
				}
	
				var uname = user.lastName;
	
				if (!_underscore2.default.isEmpty(user.firstName)) {
					uname = uname + ', ' + user.firstName;
				}
				return uname;
			},
			formatActions: function formatActions() {},
			displayList: function displayList(a) {
				if (!_underscore2.default.isArray(a)) {
					return '';
				}
				return a.join(', ');
			},
	
			inc1: function inc1(n) {
				return n + 1;
			},
			toConfirm: function toConfirm(msg, action) {
				this.confirm.action = action;
				this.confirm.msg = msg;
				this.confirm.enabled = true;
			},
			confirmDelink: function confirmDelink(n) {
				var _this = this;
	
				var user = this.user.hsUsers[n];
				var schooxid = this.su.id;
				this.toConfirm('Confirm de-link. This action will not take effect until the next sync.', function () {
					_this.$store.dispatch('delink', {
						acadid: _this.acadid,
						user: {
							hsids: user.ids,
							schooxid: schooxid
						}
					});
				});
			},
			onConfirm: function onConfirm() {
				if (this.confirm.action) {
					this.confirm.action();
				}
				this.confirm.enabled = false;
			}
		}
	};

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'error',
		computed: {
			err: function err() {
				return this.$store.state.dataError;
			}
		},
		methods: {
			reload: function reload(event) {
				event.preventDefault();
				location.reload();
			}
		}
	};

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vuedraggable = __webpack_require__(49);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: {
			'excluded': {
				type: Array,
				default: function _default() {
					return [];
				}
			},
			'available': {
				type: Array,
				default: function _default() {
					return [];
				}
			}
	
		},
		components: { draggable: _vuedraggable2.default },
		computed: {
			options: function options() {
				return {
					group: {
						name: 'excluded',
						put: true,
						clone: false
					},
					sort: false
				};
			}
		},
		methods: {
			update: function update() {
				this.$emit('update', this.excluded);
			}
		}
	};

/***/ },
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function () {
	  return function (h) {
	
	    var items = [];
	
	    this.pages.map(function (page) {
	      items.push(h(
	        "li",
	        { "class": "VuePagination__pagination-item page-item " + this.activeClass(page) },
	        [h(
	          "a",
	          { "class": "page-link", attrs: { href: "javascript:void(0);"
	            },
	            on: {
	              "click": this.setPage.bind(this, page)
	            }
	          },
	          [page]
	        )]
	      ));
	    }.bind(this));
	
	    return h(
	      "div",
	      { "class": "VuePagination" },
	      [h(
	        "ul",
	        {
	          directives: [{
	            name: "show",
	            value: this.totalPages > 1
	          }],
	
	          "class": "pagination VuePagination__pagination" },
	        [h(
	          "li",
	          { "class": "VuePagination__pagination-item page-item VuePagination__pagination-item-prev-chunk " + this.allowedChunkClass(-1) },
	          [h(
	            "a",
	            { "class": "page-link", attrs: { href: "javascript:void(0);"
	              },
	              on: {
	                "click": this.setChunk.bind(this, -1)
	              }
	            },
	            ["<<"]
	          )]
	        ), h(
	          "li",
	          { "class": "VuePagination__pagination-item page-item VuePagination__pagination-item-prev-page " + this.allowedPageClass(this.page - 1) },
	          [h(
	            "a",
	            { "class": "page-link", attrs: { href: "javascript:void(0);"
	              },
	              on: {
	                "click": this.prev.bind(this)
	              }
	            },
	            ["<"]
	          )]
	        ), items, h(
	          "li",
	          { "class": "VuePagination__pagination-item page-item VuePagination__pagination-item-next-page " + this.allowedPageClass(this.page + 1) },
	          [h(
	            "a",
	            { "class": "page-link", attrs: { href: "javascript:void(0);"
	              },
	              on: {
	                "click": this.next.bind(this)
	              }
	            },
	            [">"]
	          )]
	        ), h(
	          "li",
	          { "class": "VuePagination__pagination-item page-item VuePagination__pagination-item-next-chunk " + this.allowedChunkClass(1) },
	          [h(
	            "a",
	            { "class": "page-link", attrs: { href: "javascript:void(0);"
	              },
	              on: {
	                "click": this.setChunk.bind(this, 1)
	              }
	            },
	            [">>"]
	          )]
	        )]
	      ), h(
	        "p",
	        {
	          directives: [{
	            name: "show",
	            value: parseInt(this.records)
	          }],
	
	          "class": "VuePagination__count" },
	        [this.count]
	      )]
	    );
	  };
	};

/***/ },
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty2 = __webpack_require__(17);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (h, that) {
	
	  if (!that.opts.filterByColumn || !that.opts.filterable) return '';
	
	  var textFilter = __webpack_require__(310)(h, that);
	  var dateFilter = __webpack_require__(297)(h, that);
	  var listFilter = __webpack_require__(302)(h, that);
	
	  var filters = [];
	  var filter;
	
	  if (that.opts.childRow) filters.push(h(
	    'th',
	    null,
	    []
	  ));
	
	  that.allColumns.map(function (column) {
	
	    if (that.filterable(column)) {
	
	      switch (true) {
	        case that.isTextFilter(column):
	          filter = textFilter(column);break;
	        case that.isDateFilter(column):
	          filter = dateFilter(column);break;
	        case that.isListFilter(column):
	          filter = listFilter(column);break;
	      }
	    } else {
	      filter = '';
	    }
	
	    filters.push(h(
	      'th',
	      null,
	      [h(
	        'div',
	        (0, _defineProperty3.default)({ 'class': 'VueTables__column-filter' }, 'class', 'VueTables__' + column + '-filter-wrapper'),
	        [filter]
	      )]
	    ));
	  });
	
	  return h(
	    'tr',
	    { 'class': 'VueTables__filters-row' },
	    [filters]
	  );
	};

/***/ },
/* 297 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	  return function (column) {
	    return h(
	      'div',
	      { 'class': 'VueTables__date-filter',
	        attrs: { id: 'VueTables__' + column + '-filter' }
	      },
	      [h(
	        'span',
	        { 'class': 'VueTables__filter-placeholder' },
	        [that.display('filterBy', { column: that.getHeading(column) })]
	      )]
	    );
	  };
	};

/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	
	  if (that.count > 0 && that.opts.pagination.dropdown) {
	
	    var perPage = parseInt(that.limit);
	
	    var from = (that.Page - 1) * perPage + 1;
	    var to = that.Page == that.totalPages ? that.count : from + perPage - 1;
	
	    var parts = that.opts.texts.count.split('|');
	    var i = Math.min(that.count == 1 ? 2 : that.totalPages == 1 ? 1 : 0, parts.length - 1);
	
	    var count = parts[i].replace('{count}', that.count).replace('{from}', from).replace('{to}', to);
	
	    return h(
	      'div',
	      { 'class': 'VuePagination' },
	      [h(
	        'p',
	        { 'class': 'VuePagination__count' },
	        [count]
	      )]
	    );
	  }
	
	  return '';
	};

/***/ },
/* 299 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	
	    if (that.opts.pagination && that.opts.pagination.dropdown) {
	
	        var pages = [];
	        var selected;
	
	        for (var pag = 1; pag <= that.totalPages; pag++) {
	            var selected = that.page == pag;
	            pages.push(h(
	                'option',
	                {
	                    attrs: { value: pag, selected: selected }
	                },
	                [pag]
	            ));
	        }
	
	        var id = 'VueTables__dropdown-pagination_' + that.id;
	        return h(
	            'div',
	            { 'class': 'form-group form-inline pull-right VueTables__dropdown-pagination',
	                directives: [{
	                    name: 'show',
	                    value: that.totalPages > 1
	                }]
	            },
	            [h(
	                'label',
	                {
	                    attrs: { 'for': id }
	                },
	                [that.display('page')]
	            ), h(
	                'select',
	                { 'class': 'form-control',
	                    attrs: { name: 'page',
	
	                        value: that.page,
	
	                        id: id
	                    },
	                    ref: 'page', on: {
	                        'change': that.setPage.bind(that, null)
	                    }
	                },
	                [pages]
	            )]
	        );
	    }
	
	    return '';
	};

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(17);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (h, that) {
	
	  if (!that.opts.footerHeadings) return '';
	
	  var footerHeadings = [];
	
	  if (that.opts.footerHeadings) {
	
	    var columns = that.allColumns;
	
	    columns.map(function (column) {
	
	      footerHeadings.push(h(
	        "th",
	        {
	          on: {
	            "click": that.orderByColumn.bind(that, column)
	          },
	          "class": that.sortableClass(column) },
	        [h(
	          "span",
	          { "class": "VueTables__heading" },
	          [that.getHeading(column)]
	        ), h(
	          "span",
	          (0, _defineProperty3.default)({
	            directives: [{
	              name: "show",
	              value: that.sortable(column)
	            }],
	
	            "class": "VueTables__sort-icon pull-right"
	          }, "class", that.sortableChevronClass(column)),
	          []
	        )]
	      ));
	    });
	  }
	
	  return h(
	    "tfoot",
	    null,
	    [h(
	      "tr",
	      null,
	      [footerHeadings]
	    )]
	  );
	};

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (h, that) {
	
	  var sortControl = __webpack_require__(309)(h, that);
	
	  var headings = [];
	
	  if (that.opts.childRow) headings.push(h(
	    "th",
	    null,
	    []
	  ));
	
	  that.allColumns.map(function (column) {
	    headings.push(h(
	      "th",
	      {
	        on: {
	          "click": that.orderByColumn.bind(that, column)
	        },
	
	        "class": that.sortableClass(column) },
	      [h(
	        "span",
	        { "class": "VueTables__heading" },
	        [that.getHeading(column)]
	      ), sortControl(column)]
	    ));
	  }.bind(that));
	
	  return headings;
	};

/***/ },
/* 302 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	
	  return function (column) {
	
	    var options = [];
	    var selected = void 0;
	
	    var search = that.source == 'client' ? that.search.bind(that, that.data) : that.serverSearch.bind(that);
	
	    that.opts.listColumns[column].map(function (option) {
	      selected = option.id == that.query[column] && that.query[column] !== '';
	      options.push(h(
	        'option',
	        {
	          attrs: { value: option.id, selected: selected }
	        },
	        [option.text]
	      ));
	    });
	
	    return h(
	      'div',
	      { 'class': 'VueTables__list-filter',
	        attrs: { id: 'VueTables__' + column + '-filter' }
	      },
	      [h(
	        'select',
	        { 'class': 'form-control',
	          on: {
	            'change': search
	          },
	          attrs: {
	            name: column,
	            value: that.query[column] }
	        },
	        [h(
	          'option',
	          {
	            attrs: { value: '' }
	          },
	          [that.display('defaultOption', { column: that.getHeading(column) })]
	        ), options]
	      )]
	    );
	  };
	};

/***/ },
/* 303 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (h, that) {
	  if (that.count == 0) {
	
	    var colspan = that.allColumns.length;
	    if (that.opts.childRow) colspan++;
	
	    return h(
	      "tr",
	      { "class": "VueTables__no-results" },
	      [h(
	        "td",
	        { "class": "text-center",
	          attrs: { colspan: colspan }
	        },
	        [that.display('noResults')]
	      )]
	    );
	  }
	};

/***/ },
/* 304 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	
	  if (!that.opts.filterable) return '';
	
	  var search = that.source == 'client' ? that.search.bind(that, that.data) : that.serverSearch.bind(that);
	
	  if (that.opts.filterable && !that.opts.filterByColumn) {
	    var id = 'VueTables__search_' + that.id;
	    return h(
	      'div',
	      { 'class': 'form-group form-inline pull-left VueTables__search' },
	      [h(
	        'label',
	        {
	          attrs: { 'for': id }
	        },
	        [that.display('filter')]
	      ), h(
	        'input',
	        { 'class': 'form-control',
	          attrs: { type: 'text',
	            value: that.query,
	            placeholder: that.display('filterPlaceholder'),
	
	            id: id
	          },
	          on: {
	            'keyup': search
	          }
	        },
	        []
	      )]
	    );
	  }
	
	  return '';
	};

/***/ },
/* 305 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (h, that) {
	  if (that.opts.pagination && !that.opts.pagination.dropdown) {
	
	    var name = that.vuex ? that.name : that.id;
	
	    return h(
	      "pagination",
	      {
	        ref: "pagination",
	        attrs: { "for": name,
	          records: that.count,
	          "per-page": parseInt(that.limit),
	          chunk: that.opts.pagination.chunk,
	          "count-text": that.opts.texts.count }
	      },
	      []
	    );
	  }
	
	  return '';
	};

/***/ },
/* 306 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (h, that) {
	  var perpageValues = [];
	
	  that.opts.perPageValues.every(function (value) {
	    var isLastEntry = value >= that.count;
	    var selected = that.limit == value || isLastEntry && that.limit > value;
	    perpageValues.push(h(
	      "option",
	      {
	        attrs: { value: value, selected: selected }
	      },
	      [value]
	    ));
	    return !isLastEntry;
	  });
	
	  return perpageValues;
	};

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (h, that) {
	
	  var perpageValues = __webpack_require__(306)(h, that);
	
	  if (perpageValues.length > 1) {
	    var id = 'VueTables__limit_' + that.id;
	    return h(
	      'div',
	      { 'class': 'form-group form-inline pull-right VueTables__limit' },
	      [h(
	        'label',
	        {
	          attrs: { 'for': id }
	        },
	        [that.display('limit')]
	      ), h(
	        'select',
	        { 'class': 'form-control',
	          attrs: { name: 'limit',
	            value: that.limit,
	
	            id: id
	          },
	          on: {
	            'change': that.setLimit.bind(that)
	          }
	        },
	        [perpageValues]
	      )]
	    );
	  }
	
	  return '';
	};

/***/ },
/* 308 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	  var rows = [];
	  var columns;
	  var rowKey = that.opts.childRowKey;
	
	  var data = that.source == 'client' ? that.filteredData : that.tableData;
	
	  data.map(function (row, index) {
	    columns = [];
	
	    if (that.opts.childRow) columns.push(h(
	      'td',
	      null,
	      [h(
	        'span',
	        {
	          on: {
	            'click': that.toggleChildRow.bind(that, row[rowKey])
	          },
	          'class': 'VueTables__child-row-toggler ' + that.childRowTogglerClass(row[rowKey]) },
	        []
	      )]
	    ));
	
	    that.allColumns.map(function (column) {
	      columns.push(h(
	        'td',
	        null,
	        [that.render(row, column, h)]
	      ));
	    }.bind(that));
	
	    rows.push(h(
	      'tr',
	      {
	        on: {
	          'click': that.rowWasClicked.bind(that, row)
	        }
	      },
	      [columns, ' ']
	    ));
	
	    if (that.opts.childRow) {
	      var childRow = that.opts.childRow;
	      var template = typeof childRow === 'function' ? childRow.apply(that, [h, row]) : h(childRow, {
	        attrs: {
	          data: row
	        }
	      });
	      rows.push(h(
	        'tr',
	        { 'class': 'VueTables__child-row ' + that.childRowClass(row[rowKey]) },
	        [h(
	          'td',
	          {
	            attrs: { colspan: that.allColumns.length + 1 }
	          },
	          [template]
	        )]
	      ));
	    }
	  }.bind(that));
	
	  return rows;
	};

/***/ },
/* 309 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	  return function (column) {
	
	    if (!that.sortable(column)) return '';
	    return h(
	      'span',
	      { 'class': 'VueTables__sort-icon pull-right ' + that.sortableChevronClass(column) },
	      []
	    );
	  }.bind(that);
	};

/***/ },
/* 310 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (h, that) {
	
	      var search = that.source == 'client' ? that.search.bind(that, that.data) : that.serverSearch.bind(that);
	
	      return function (column) {
	            return h(
	                  "input",
	                  {
	                        on: {
	                              "keyup": search
	                        },
	
	                        "class": "form-control",
	                        attrs: { name: column,
	                              type: "text",
	                              placeholder: that.display('filterBy', { column: that.getHeading(column) }),
	                              value: that.query[column]
	                        }
	                  },
	                  []
	            );
	      };
	};

/***/ },
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 357 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 358 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 359 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 360 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 361 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 362 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 363 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 364 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 365 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 366 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 367 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 368 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 369 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 370 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 371 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 372 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 373 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 374 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 375 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 376 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 377 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 378 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 379 */,
/* 380 */,
/* 381 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 382 */,
/* 383 */,
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(376)
	
	/* script */
	__vue_exports__ = __webpack_require__(210)
	
	/* template */
	var __vue_template__ = __webpack_require__(421)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(369)
	
	/* script */
	__vue_exports__ = __webpack_require__(211)
	
	/* template */
	var __vue_template__ = __webpack_require__(414)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(362)
	
	/* script */
	__vue_exports__ = __webpack_require__(212)
	
	/* template */
	var __vue_template__ = __webpack_require__(407)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(370)
	
	/* script */
	__vue_exports__ = __webpack_require__(213)
	
	/* template */
	var __vue_template__ = __webpack_require__(415)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(363)
	
	/* script */
	__vue_exports__ = __webpack_require__(214)
	
	/* template */
	var __vue_template__ = __webpack_require__(408)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-291bb43f"
	
	module.exports = __vue_exports__


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(373)
	
	/* script */
	__vue_exports__ = __webpack_require__(215)
	
	/* template */
	var __vue_template__ = __webpack_require__(418)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bf070260"
	
	module.exports = __vue_exports__


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(372)
	
	/* script */
	__vue_exports__ = __webpack_require__(216)
	
	/* template */
	var __vue_template__ = __webpack_require__(417)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(360)
	
	/* script */
	__vue_exports__ = __webpack_require__(217)
	
	/* template */
	var __vue_template__ = __webpack_require__(405)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(375)
	
	/* script */
	__vue_exports__ = __webpack_require__(218)
	
	/* template */
	var __vue_template__ = __webpack_require__(420)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(365)
	
	/* script */
	__vue_exports__ = __webpack_require__(219)
	
	/* template */
	var __vue_template__ = __webpack_require__(410)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(367)
	
	/* script */
	__vue_exports__ = __webpack_require__(220)
	
	/* template */
	var __vue_template__ = __webpack_require__(412)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(371)
	
	/* script */
	__vue_exports__ = __webpack_require__(221)
	
	/* template */
	var __vue_template__ = __webpack_require__(416)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(357)
	
	/* script */
	__vue_exports__ = __webpack_require__(223)
	
	/* template */
	var __vue_template__ = __webpack_require__(402)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(361)
	
	/* script */
	__vue_exports__ = __webpack_require__(224)
	
	/* template */
	var __vue_template__ = __webpack_require__(406)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(358)
	
	/* script */
	__vue_exports__ = __webpack_require__(226)
	
	/* template */
	var __vue_template__ = __webpack_require__(403)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(364)
	
	/* script */
	__vue_exports__ = __webpack_require__(227)
	
	/* template */
	var __vue_template__ = __webpack_require__(409)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(374)
	
	/* script */
	__vue_exports__ = __webpack_require__(228)
	
	/* template */
	var __vue_template__ = __webpack_require__(419)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(359)
	
	/* script */
	__vue_exports__ = __webpack_require__(229)
	
	/* template */
	var __vue_template__ = __webpack_require__(404)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 402 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "troubleshooting"
	  }, [_c('TroubleshootingMenu', {
	    attrs: {
	      "tab": "user"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "troubleshooting-query"
	  }, [_c('div', [_c('label', [_vm._v("Academy Id")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.acadid),
	      expression: "acadid"
	    }, {
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.acadid),
	      expression: "acadid",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    staticClass: "text-input bg-white",
	    attrs: {
	      "type": "text",
	      "data-vv-rules": "required|numeric",
	      "data-vv-name": "Academy Id"
	    },
	    domProps: {
	      "value": _vm._s(_vm.acadid)
	    },
	    on: {
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return; }
	        _vm.search($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.acadid = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button raised",
	    attrs: {
	      "disabled": _vm.searching
	    },
	    on: {
	      "click": _vm.search
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), (_vm.errors.has('Academy Id')) ? _c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('Academy Id')))]) : _vm._e()])]), _vm._v(" "), (_vm.searching) ? _c('div', [_c('loading-bar'), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.waitmsg))])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.noMappings) ? _c('div', [_c('p', [_vm._v("No mappings found for " + _vm._s(_vm.acadid) + ". Check to make sure Academy ID is valid.")])]) : _vm._e(), _vm._v(" "), (_vm.mappingsReady) ? _c('div', {
	    staticClass: "clearfix"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('span', {
	    staticClass: "action-label"
	  }, [_vm._v("Show Raw Data:")]), _vm._v(" "), _c('Toggle', {
	    attrs: {
	      "value": _vm.showRaw
	    },
	    on: {
	      "change": function($event) {
	        _vm.showRaw = !_vm.showRaw
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "user-count"
	  }, [_c('strong', [_vm._v("Zombie Users (No SSO Mapping):")]), _vm._v(" " + _vm._s(_vm.zombies))]), _vm._v(" "), _c('span', {
	    staticClass: "user-count"
	  }, [_c('strong', [_vm._v("Mismatched Users: ")]), _vm._v(_vm._s(_vm.mmCount))]), _vm._v(" "), (_vm.mmCount !== 0) ? _c('button', {
	    on: {
	      "click": _vm.getReport
	    }
	  }, [_vm._v("Download Mismatched Users Report")]) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showRaw),
	      expression: "!showRaw"
	    }]
	  }, [(_vm.detaillUser) ? _c('div', [_c('button', {
	    staticClass: "pull-right",
	    on: {
	      "click": _vm.clearDetails
	    }
	  }, [_vm._v("Return to User List")]), _vm._v(" "), _c('h3', [_vm._v("User Details")]), _vm._v(" "), _c('user-details', {
	    attrs: {
	      "user": _vm.detaillUser,
	      "acadid": _vm.acadid
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.mappingsReady) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.detaillUser),
	      expression: "!detaillUser"
	    }],
	    staticClass: "search-result"
	  }, [_c('v-client-table', {
	    attrs: {
	      "data": _vm.rows,
	      "columns": _vm.columns,
	      "options": _vm.options
	    }
	  })]) : _vm._e()]), _vm._v(" "), (_vm.showRaw) ? _c('div', [(_vm.detaillUser) ? _c('button', {
	    staticClass: "pull-right",
	    on: {
	      "click": function($event) {
	        _vm.detaillUserIndex = null
	      }
	    }
	  }, [_vm._v("Return to User List")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Raw Results Data")]), _vm._v(" "), _c('div', {
	    staticClass: "rawResult"
	  }, [_c('pre', [_vm._v(_vm._s(_vm.rawData))])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 403 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return (_vm.loggedIn) ? _c('div', {
	    staticClass: "user-actions pull-right"
	  }, [_c('span', [_vm._v("Welcome back " + _vm._s(_vm.username))]), _c('a', {
	    staticClass: "fancy-link",
	    on: {
	      "click": _vm.logout
	    }
	  }, [_vm._v("logout")])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 404 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "excluded-jobs-editor"
	  }, [_c('table', {
	    staticClass: "table table-striped table-bordered config-table"
	  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Synced Jobs")]), _vm._v(" "), _c('td', [_c('draggable', {
	    staticClass: "excluded-container",
	    attrs: {
	      "list": _vm.available,
	      "options": _vm.options
	    }
	  }, _vm._l((_vm.available), function(name) {
	    return _c('div', {
	      staticClass: "excluded-dragger"
	    }, [_vm._v(_vm._s(name))])
	  }))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Excluded Jobs")]), _vm._v(" "), _c('td', [_c('draggable', {
	    staticClass: "excluded-container",
	    attrs: {
	      "list": _vm.excluded,
	      "options": _vm.options
	    },
	    on: {
	      "add": _vm.update,
	      "remove": _vm.update
	    }
	  }, _vm._l((_vm.excluded), function(name) {
	    return _c('div', {
	      staticClass: "excluded-dragger"
	    }, [_vm._v(_vm._s(name))])
	  }))])])])])])
	},staticRenderFns: []}

/***/ },
/* 405 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('h2', {}, [_vm._v("HotSchedules Academy Mappings")]), _vm._v(" "), _c('div', {
	    staticClass: "academy-listings"
	  }, [_c('v-client-table', {
	    attrs: {
	      "data": _vm.tableData,
	      "columns": _vm.columns,
	      "options": _vm.options
	    }
	  })])])
	},staticRenderFns: []}

/***/ },
/* 406 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "troubleshooting-loc"
	  }, [_c('TroubleshootingMenu', {
	    attrs: {
	      "tab": "location"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "troubleshooting-query"
	  }, [_c('label', [_vm._v("extCompRef")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.extCompRef),
	      expression: "extCompRef"
	    }, {
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.extCompRef),
	      expression: "extCompRef",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    staticClass: "text-input bg-white",
	    attrs: {
	      "name": "extCompRef",
	      "type": "text",
	      "data-vv-rules": "required|numeric",
	      "data-vv-name": "extCompRef"
	    },
	    domProps: {
	      "value": _vm._s(_vm.extCompRef)
	    },
	    on: {
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return; }
	        _vm.search($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.extCompRef = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.has('extCompRef')) ? _c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('extCompRef')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Location/Node ID")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.storeId),
	      expression: "storeId"
	    }, {
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.storeId),
	      expression: "storeId",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    staticClass: "text-input bg-white",
	    attrs: {
	      "name": "storeId",
	      "type": "text",
	      "data-vv-rules": "required|numeric",
	      "data-vv-name": "Location/Node Id"
	    },
	    domProps: {
	      "value": _vm._s(_vm.storeId)
	    },
	    on: {
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return; }
	        _vm.search($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.storeId = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.has('Location/Node Id')) ? _c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('Location/Node Id')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
	    staticClass: "button raised",
	    attrs: {
	      "disabled": _vm.searching
	    },
	    on: {
	      "click": _vm.search
	    }
	  }, [_vm._v("Search")])]), _vm._v(" "), (_vm.searching) ? _c('div', [_c('loading-bar'), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.waitmsg))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.res) ? _c('div', [_vm._v("\n\t\tLocation/Node was found in HS Hierarchy.xml. Users for this locations should be synced.\n\t\t"), _c('table', {
	    staticClass: "table table-striped table-bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.resid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resdesc))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.err))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Location/Node ID")]), _vm._v(" "), _c('th', [_vm._v("Location/Node")])])])
	}]}

/***/ },
/* 407 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "academy-search"
	  }, [_c('h2', {}, [_vm._v("Academy Search")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.extCompRef),
	      expression: "extCompRef"
	    }],
	    staticClass: "text-input bg-white",
	    attrs: {
	      "type": "text",
	      "placeholder": "extCompRef"
	    },
	    domProps: {
	      "value": _vm._s(_vm.extCompRef)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.extCompRef = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("and/or")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.acadid),
	      expression: "acadid"
	    }],
	    staticClass: "text-input bg-white",
	    attrs: {
	      "type": "text",
	      "placeholder": "Schoox Academy ID"
	    },
	    domProps: {
	      "value": _vm._s(_vm.acadid)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.acadid = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button raised",
	    on: {
	      "click": _vm.search
	    }
	  }, [_vm._v("Search")])]), _vm._v(" "), _c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.err),
	      expression: "err"
	    }],
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.err))]), _vm._v(" "), (_vm.searched) ? _c('div', {
	    staticClass: "search-results"
	  }, [_c('h3', [_vm._v("Search Results")]), _vm._v(" "), (_vm.resultsCount == 0) ? _c('div', [_c('p', [_vm._v("No records found")])]) : _c('div', [_c('div', [_c('v-client-table', {
	    attrs: {
	      "data": _vm.tableData,
	      "columns": _vm.columns,
	      "options": _vm.options
	    }
	  })])]), _vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "search-results"
	  })])
	},staticRenderFns: []}

/***/ },
/* 408 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "menu-bar bg-light-green"
	  }, [(_vm.loggedIn) ? _c('div', _vm._l((_vm.items), function(item, index) {
	    return _c('router-link', {
	      staticClass: "btn menu-action color-dark-grey",
	      attrs: {
	        "to": item.path
	      }
	    }, [_c('i', {
	      class: 'fa fa-' + item.icon + ' color-white'
	    }), _c('span', [_vm._v(_vm._s(item.title))])])
	  })) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 409 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "user-details"
	  }, [(_vm.confirm.enabled) ? _c('confirm', {
	    on: {
	      "cancel": function($event) {
	        _vm.confirm.enabled = false
	      },
	      "confirm": _vm.onConfirm
	    }
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirm.msg)
	    },
	    slot: "body"
	  })]) : _vm._e(), _vm._v(" "), _c('h4', {
	    staticClass: "bg-blue-grey"
	  }, [_vm._v("SyncActions")]), _vm._v(" "), (_vm.user.actions.length) ? _c('div', [_c('table', {
	    staticClass: "split-50 table table-striped table-bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.user.actions), function(action) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(action.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.reason))])])
	  }))])]) : _c('div', {
	    staticClass: "bordered-row"
	  }, [_c('p', [_vm._v("No pending sync actions")])]), _vm._v(" "), _vm._v(" "), _c('h4', {
	    staticClass: "bg-blue-grey"
	  }, [_vm._v("User Data")]), _vm._v(" "), _c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('h4', {
	    staticClass: "bg-light-green"
	  }, [_vm._v("Schoox User")]), _vm._v(" "), _c('table', {
	    staticClass: "user-details-table table table-striped table-bordered"
	  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.suName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Id:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.su.id))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.su.email))])])])]), _vm._v(" "), _c('h4', {
	    staticClass: "bg-light-green"
	  }, [_vm._v("Locations")]), _vm._v(" "), _c('table', {
	    staticClass: "split-50 table table-striped table-bordered"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.su.schooxLocations), function(loc) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(loc.name))]), _vm._v(" "), _c('td', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.getJobs(loc.jobs))
	      }
	    })])
	  }))]), _vm._v(" "), _c('h4', {
	    staticClass: "bg-light-green"
	  }, [_vm._v("Academy Members")]), _vm._v(" "), _c('table', {
	    staticClass: "split-50 table table-striped table-bordered"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.su.acadMembers), function(member) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(member.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.hourlyWorker))])])
	  }))]), _vm._v(" "), _c('h4', {
	    staticClass: "bg-light-green"
	  }, [_vm._v("SSO Users")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-striped table-bordered"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.su.ssoUsers), function(sso) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(sso.userId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sso.ssoId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sso.externalId))]), _vm._v(" "), _c('td', [_c('span', {
	      directives: [{
	        name: "timestamp",
	        rawName: "v-timestamp",
	        value: (sso.timeAdded),
	        expression: "sso.timeAdded"
	      }]
	    })]), _vm._v(" "), _c('td', [_c('span', {
	      directives: [{
	        name: "timestamp",
	        rawName: "v-timestamp",
	        value: (sso.modifiedAt),
	        expression: "sso.modifiedAt"
	      }]
	    })])])
	  }))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_vm._l((_vm.user.hsUsers), function(hsu, i) {
	    return [_c('h4', {
	      staticClass: "bg-blue-hs"
	    }, [_c('button', {
	      staticClass: "pull-right",
	      on: {
	        "click": function($event) {
	          _vm.confirmDelink(i)
	        }
	      }
	    }, [_vm._v("Delink User")]), _vm._v("HotSchedules User " + _vm._s(_vm.inc1(i)))]), _vm._v(" "), _c('table', {
	      staticClass: "table table-striped table-bordered"
	    }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getUserName(hsu)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ids:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayList(hsu.ids)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hsu.email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HRID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hsu.hrid))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Asc:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hsu.asc))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Active")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hsu.active))])])])]), _vm._v(" "), _c('h4', {
	      staticClass: "bg-blue-hs"
	    }, [_vm._v("Locations")]), _vm._v(" "), (hsu.locations.length) ? _c('table', {
	      staticClass: "table table-striped table-bordered"
	    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', _vm._l((hsu.locations), function(loc, li) {
	      return _c('tr', [_c('td', [_vm._v(_vm._s(loc.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(loc.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(loc.acadId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(loc.hierarchyid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(loc.extCompRef))]), _vm._v(" "), _c('td', {
	        domProps: {
	          "innerHTML": _vm._s(_vm.getJobs(loc.jobs))
	        }
	      })])
	    }))]) : _c('div', {
	      staticClass: "bordered-row"
	    }, [_c('p', [_vm._v("No Locations Listed")])]), _vm._v(" "), _vm._v(" "), _c('h4', {
	      staticClass: "bg-blue-hs"
	    }, [_vm._v("Employee Set")]), _vm._v(" "), (hsu.employeeSet.set.length) ? _c('table', {
	      staticClass: "table table-striped table-bordered table-compact"
	    }, [_vm._m(5, true), _vm._v(" "), _c('tbody', _vm._l((hsu.employeeSet.set), function(row) {
	      return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.getUserName(row.employee)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employee.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employee.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employee.hrid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.location.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employee.active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.location.hierarchyid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.location.extCompRef))]), _vm._v(" "), _c('td', {
	        domProps: {
	          "innerHTML": _vm._s(_vm.getJobs(row.employee.jobs))
	        }
	      })])
	    }))]) : _c('div', {
	      staticClass: "bordered-row"
	    }, [_c('p', [_vm._v("No Employee Set Data")])]), _vm._v(" ")]
	  })], true)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Sync Action Description (for next sync)")]), _vm._v(" "), _c('th', [_vm._v("Sync Action Reason")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("jobs")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("id")]), _vm._v(" "), _c('th', [_vm._v("Hourly")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("User Id")]), _vm._v(" "), _c('th', [_vm._v("SSO Id")]), _vm._v(" "), _c('th', [_vm._v("External Id")]), _vm._v(" "), _c('th', [_vm._v("Added")]), _vm._v(" "), _c('th', [_vm._v("Last Modified")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Academy Id")]), _vm._v(" "), _c('th', [_vm._v("Hierarchy Id")]), _vm._v(" "), _c('th', [_vm._v("extCompRef")]), _vm._v(" "), _c('th', [_vm._v("jobs")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("HRID")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Active")]), _vm._v(" "), _c('th', [_vm._v("Hierarchy Id")]), _vm._v(" "), _c('th', [_vm._v("extCompRef")]), _vm._v(" "), _c('th', [_vm._v("Jobs")])])])
	}]}

/***/ },
/* 410 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('div', [_c('ProgressStepper', {
	    staticClass: "stepper",
	    attrs: {
	      "steps": _vm.steps,
	      "currentStep": _vm.currentStep
	    }
	  }), _vm._v(" "), _c('h2', [_vm._v("Mapping Tool")])]), _vm._v(" "), _c('div', {
	    staticClass: "mapping-tool"
	  }, [(_vm.currentStep == 0) ? _c('div', [_c('h3', [_vm._v("Step 1: " + _vm._s(_vm.steps[0]))]), _vm._v(" "), _c('form', {
	    staticClass: "form-inline"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "acadid"
	    }
	  }, [_vm._v("Academy Id:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.acadid),
	      expression: "acadid"
	    }, {
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.acadid),
	      expression: "acadid",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "acadid",
	      "data-vv-rules": "required|numeric",
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.acadid)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.acadid = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button raised",
	    on: {
	      "click": _vm.seachAcademy
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), (_vm.acaderror) ? _c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.acaderror))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.currentStep == 1) ? _c('div', [_c('p', [_vm._v("Academy: " + _vm._s(_vm.academy.acadid) + " - " + _vm._s(_vm.academy.acadName))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Step 2: " + _vm._s(_vm.steps[1]))]), _vm._v(" "), _c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('form', {
	    staticClass: "form-inline"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "extCompRef"
	    }
	  }, [_vm._v("extCompRef: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.extCompRef),
	      expression: "extCompRef"
	    }, {
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.extCompRef),
	      expression: "extCompRef",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "extCompRef",
	      "type": "text",
	      "data-vv-rules": "required|numeric",
	      "id": "extCompRef"
	    },
	    domProps: {
	      "value": _vm._s(_vm.extCompRef)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.extCompRef = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.submitExtCompRef
	    }
	  }, [_vm._v("Submit")])])]), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [(_vm.ecrerror) ? _c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.ecrerror))]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), (_vm.currentStep == 2) ? _c('div', [_c('p', [_vm._v("Academy: " + _vm._s(_vm.academy.acadid) + " - " + _vm._s(_vm.academy.acadName))]), _vm._v(" "), _c('p', [_vm._v("extCompRef: " + _vm._s(_vm.ecr.extCompRef) + " - " + _vm._s(_vm.ecr.company))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Step 3: " + _vm._s(_vm.steps[2]))]), _vm._v(" "), _c('div', {
	    staticClass: "form-inline"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.location),
	      expression: "location"
	    }],
	    on: {
	      "change": function($event) {
	        _vm.location = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.locations), function(option) {
	    return _c('option', {
	      domProps: {
	        "value": option
	      }
	    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(option.nodeid) + " - " + _vm._s(option.description) + "\n\t\t\t\t")])
	  })), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.submitLocation
	    }
	  }, [_vm._v("Select")])])]) : _vm._e(), _vm._v(" "), (_vm.currentStep == 3) ? _c('div', [_c('h3', [_vm._v("Step 4: " + _vm._s(_vm.steps[3]))]), _vm._v(" "), _c('p', [_vm._v("Academy: " + _vm._s(_vm.academy.acadid) + " - " + _vm._s(_vm.academy.acadName))]), _vm._v(" "), _c('p', [_vm._v("extCompRef: " + _vm._s(_vm.ecr.extCompRef) + " - " + _vm._s(_vm.ecr.company))]), _vm._v(" "), _c('p', [_vm._v("Location: " + _vm._s(_vm.location.nodeid) + " - " + _vm._s(_vm.location.description))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('button', {
	    on: {
	      "click": _vm.confirmCreateMapping
	    }
	  }, [_vm._v("Confirm and Create Mapping")])])]) : _vm._e(), _vm._v(" "), (_vm.currentStep == 4) ? _c('div', [_c('h3', [_vm._v("Mapping Created")]), _vm._v(" "), _c('p', [_vm._v("Academy: " + _vm._s(_vm.academy.acadid) + " - " + _vm._s(_vm.academy.acadName))]), _vm._v(" "), _c('p', [_vm._v("extCompRef: " + _vm._s(_vm.ecr.extCompRef) + " - " + _vm._s(_vm.ecr.company))]), _vm._v(" "), _c('p', [_vm._v("Location: " + _vm._s(_vm.location.nodeid) + " - " + _vm._s(_vm.location.description))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('button', {
	    on: {
	      "click": _vm.reset
	    }
	  }, [_vm._v("Add Another Mapping")])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 411 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "toggle-container"
	  }, [_c('div', {
	    staticClass: "toggle"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    staticClass: "toggle-checkbox",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, null) > -1 : _vm._q(_vm.value, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.value,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.value = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.value = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "toggle-label",
	    on: {
	      "click": _vm.change
	    }
	  }, [_c('span', {
	    staticClass: "toggle-inner"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "toggle-switch"
	  })])])])
	},staticRenderFns: []}

/***/ },
/* 412 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "pay-rate-editor"
	  }, [_c('table', {
	    staticClass: "table table-striped table-bordered config-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("Salaried")]), _vm._v(" "), _c('td', [_c('draggable', {
	    staticClass: "pay-type-container",
	    attrs: {
	      "list": _vm.salary,
	      "options": _vm.options
	    }
	  }, _vm._l((_vm.salary), function(name) {
	    return _c('div', {
	      staticClass: "pay-dragger"
	    }, [_vm._v(_vm._s(name))])
	  }))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Hourly")]), _vm._v(" "), _c('td', [_c('draggable', {
	    staticClass: "pay-type-container",
	    attrs: {
	      "list": _vm.hourly,
	      "options": _vm.options
	    },
	    on: {
	      "add": _vm.update,
	      "remove": _vm.update
	    }
	  }, _vm._l((_vm.hourly), function(name) {
	    return _c('div', {
	      staticClass: "pay-dragger"
	    }, [_vm._v(_vm._s(name))])
	  }))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Pay Type")]), _vm._v(" "), _c('th', [_vm._v("Schoox Job Names")])])])
	}]}

/***/ },
/* 413 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('h2', [_vm._v("Troubleshooting")]), _vm._v(" "), _c('ul', {
	    staticClass: "nav nav-tabs"
	  }, [_c('li', {
	    staticClass: "nav-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    class: {
	      active: _vm.user
	    },
	    attrs: {
	      "to": "/troubleshooting",
	      "href": "#"
	    }
	  }, [_vm._v("Users")])]), _vm._v(" "), _c('li', {
	    staticClass: "nav-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    class: {
	      active: _vm.location
	    },
	    attrs: {
	      "to": "/troubleshootingloc",
	      "href": "#"
	    }
	  }, [_vm._v("Location")])])])])
	},staticRenderFns: []}

/***/ },
/* 414 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [(_vm.valid) ? _c('div', [(_vm.working) ? _c('div', {
	    staticClass: "working"
	  }, [_c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("Academy data is being processed. This may take a few minutes.")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "pull-right clearfix"
	  }, [_c('div', [_c('strong', [_vm._v("Last Sync:")]), _vm._v(" " + _vm._s(_vm.status.lastSync) + "    "), _c('strong', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.status.status))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "text-right"
	  }, [_c('button', {
	    attrs: {
	      "disabled": !_vm.status.syncAvailable
	    },
	    on: {
	      "click": _vm.confirmSync
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o-notch",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Sync Now")]), _vm._v("   \n\t\t\t\t"), _c('router-link', {
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'troubleshooting',
	        params: {
	          acadid: _vm.academy.id
	        }
	      },
	      "disabled": !_vm.status.syncAvailable
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-address-card"
	  }), _vm._v(" Troubleshoot")])])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.academy.name))]), _vm._v(" "), (_vm.confirm.enabled) ? _c('confirm', {
	    on: {
	      "cancel": function($event) {
	        _vm.confirm.enabled = false
	      },
	      "confirm": _vm.onConfirm
	    }
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirm.msg)
	    },
	    slot: "body"
	  })]) : _vm._e(), _vm._v(" "), (_vm.progress.active) ? _c('div', {
	    staticClass: "section"
	  }, [_c('h3', [_vm._v("Sync Progress")]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-success progress-bar-striped active",
	    style: ({
	      width: _vm.progress.percent + '%'
	    })
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.progress.percent) + "% Complete - " + _vm._s(_vm.progress.msg))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "section sync-actions clearfix"
	  }, [_c('h3', [_vm._v("Options")]), _vm._v(" "), _c('div', {
	    staticClass: "toggles"
	  }, [_c('div', {
	    staticClass: "option-group"
	  }, [_c('span', {
	    staticClass: "action-label"
	  }, [_vm._v("HRID sync:")]), _vm._v(" "), _c('Toggle', {
	    attrs: {
	      "value": _vm.hridSync
	    },
	    on: {
	      "change": _vm.confirmToggleHRID
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "option-group"
	  }, [_c('span', {
	    staticClass: "action-label"
	  }, [_vm._v("ASC user sync:")]), _vm._v(" "), _c('Toggle', {
	    attrs: {
	      "value": _vm.ascUserSync
	    },
	    on: {
	      "change": _vm.confirmToggleASC
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "option-group"
	  }, [_c('span', {
	    staticClass: "action-label"
	  }, [_vm._v("Push HRIDs to Schoox:")]), _vm._v(" "), _c('Toggle', {
	    attrs: {
	      "value": _vm.hridPush
	    },
	    on: {
	      "change": _vm.confirmPushHRID
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "delay-options"
	  }, [_c('span', {
	    staticClass: "action-label"
	  }, [_vm._v("Delay removal:")]), _vm._v(" "), _c('Toggle', {
	    attrs: {
	      "value": _vm.delay.action
	    },
	    on: {
	      "change": _vm.confirmDelayRemove
	    }
	  }), _vm._v(" "), _c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.days),
	      expression: "days"
	    }],
	    staticClass: "form-control delay-days",
	    attrs: {
	      "type": "number",
	      "disabled": !_vm.delay.action,
	      "min": "delayMin",
	      "max": "delayMax"
	    },
	    domProps: {
	      "value": _vm._s(_vm.days)
	    },
	    on: {
	      "blur": [_vm.saveDelayDays, function($event) {
	        _vm.$forceUpdate()
	      }],
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return; }
	        _vm.saveDelayDays($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.days = _vm._n($event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "ignore-container"
	  }, [_c('div', [_c('span', {
	    staticClass: "action-label"
	  }, [_vm._v("HotSchedules id ignore list:")]), _vm._v(" "), _c('div', {
	    staticClass: "add-ignore-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ignoreToAdd),
	      expression: "ignoreToAdd"
	    }],
	    staticClass: "ignore-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.ignoreToAdd)
	    },
	    on: {
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return; }
	        _vm.addIgnore($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ignoreToAdd = $event.target.value
	      }
	    }
	  }), _c('button', {
	    on: {
	      "click": _vm.addIgnore
	    }
	  }, [_vm._v("Add HotSchedules id")])])]), _vm._v(" "), _c('div', {
	    staticClass: "ignores-list"
	  }, _vm._l((_vm.ignores), function(ignore) {
	    return _c('span', {
	      staticClass: "ignore-item"
	    }, [_vm._v(_vm._s(ignore) + " "), _c('i', {
	      staticClass: "fa fa-times",
	      on: {
	        "click": function($event) {
	          _vm.removeIgnore(ignore)
	        }
	      }
	    })])
	  }))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "section"
	  }, [_c('h3', [_vm._v("Pay Type Mappings")]), _vm._v(" "), (_vm.paytypeJobsReady) ? _c('div', [_c('pay-config', {
	    attrs: {
	      "hourly": _vm.hourly,
	      "salary": _vm.salary
	    },
	    on: {
	      "update": _vm.updatePayType
	    }
	  })]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.paytypeJobsMessage))])]), _vm._v(" ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "section"
	  }, [_c('h3', [_vm._v("Exclude Jobs")]), _vm._v(" "), (_vm.jobsmapReady) ? _c('div', [_c('exclude-jobs', {
	    attrs: {
	      "available": _vm.syncedJobs,
	      "excluded": _vm.exludedJobs
	    },
	    on: {
	      "update": _vm.updateExcludedJobs
	    }
	  })]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.jobsmapMessage))])]), _vm._v(" ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "section"
	  }, [_c('h3', [_vm._v("Job Name Mappings")]), _vm._v(" "), (_vm.jobsmapReady) ? _c('div', [_c('table', {
	    staticClass: "table table-striped table-bordered config-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Schoox Job Name")]), _vm._v(" "), _c('th', [_vm._v("HS Job Names")]), _vm._v(" "), _c('th', [_vm._v("# Jobs")]), _vm._v(" "), _c('th', [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.editJobMapping(_vm.jobsmap.length)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Add Job Mapping")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.jobsmap), function(row, index) {
	    return [(_vm.jobEditor.index === index) ? _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "4"
	      }
	    }, [_c('job-config', {
	      attrs: {
	        "toName": row.scxJobName,
	        "hsNames": row.hsNames,
	        "index": index,
	        "available": _vm.availableJobs,
	        "restricted": _vm.getRestrictedNames(row.scxJobName)
	      },
	      on: {
	        "ready": _vm.scroll,
	        "cancel": _vm.cancelJobMapEdit,
	        "finish": _vm.finishJobNameEdit
	      }
	    })])]) : _c('tr', [_c('td', [_vm._v(_vm._s(row.scxJobName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.hsNames.join(', ')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.hsNames.length))]), _vm._v(" "), _c('td', [_c('button', {
	      on: {
	        "click": function($event) {
	          _vm.editJobMapping(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-edit",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Edit")]), _vm._v(" "), _c('button', {
	      on: {
	        "click": function($event) {
	          _vm.confirmJobNameRemove(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Remove")])])]), _vm._v(" ")]
	  }), _vm._v(" "), (_vm.jobEditor.index === _vm.jobsmap.length) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('job-config', {
	    attrs: {
	      "index": _vm.jobsmap.length,
	      "available": _vm.availableJobs,
	      "restricted": _vm.getRestrictedNames()
	    },
	    on: {
	      "ready": _vm.scroll,
	      "cancel": _vm.cancelJobMapEdit,
	      "finish": _vm.finishJobNameEdit
	    }
	  })])]) : _vm._e()], true)]), _vm._v(" "), (!_vm.jobsmap.length) ? _c('p', [_vm._v("No Job Name Mappings. Click Add Job Name Mapping to get started.")]) : _vm._e()]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.jobsmapMessage))])]), _vm._v(" ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('router-link', {
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'mapping',
	        params: {
	          acadid: _vm.academy.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-map"
	  }), _vm._v(" Add Mapping")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.confirmRemoveAll
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Remove All Mappings")])]), _vm._v(" "), _c('h3', [_vm._v("Academy Mappings")]), _vm._v(" "), _c('v-client-table', {
	    attrs: {
	      "data": _vm.tableData,
	      "columns": _vm.columns,
	      "options": _vm.options
	    }
	  })])]) : _c('div', [_c('h2', [_vm._v("No Academy found for " + _vm._s(_vm.$route.params.id))])]), _vm._v(" ")])
	},staticRenderFns: []}

/***/ },
/* 415 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('div', {
	    staticClass: "pull-right text-right"
	  }, [_vm._v("\n\t\tFilter by Academy Id: "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }, {
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.filter),
	      expression: "filter",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    attrs: {
	      "name": "filter",
	      "type": "text",
	      "data-vv-rules": "numeric",
	      "placeholder": "Academy Id"
	    },
	    domProps: {
	      "value": _vm._s(_vm.filter)
	    },
	    on: {
	      "blur": _vm.updateFilter,
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) { return; }
	        _vm.updateFilter($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.has('filter')) ? _c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v("invald academy id")]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v("Activity Log")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadMore),
	      expression: "loadMore"
	    }],
	    staticClass: "activity-log-container",
	    attrs: {
	      "infinite-scroll-disabled": "loading",
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('table', {
	    staticClass: "table table-striped table-bordered activity-log-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.logdata), function(row) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(row.firstname) + " " + _vm._s(row.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.acadid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.action))]), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "timestamp",
	        rawName: "v-timestamp",
	        value: (row.time),
	        expression: "row.time"
	      }]
	    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.status))])])
	  }))]), _vm._v(" "), (_vm.loading) ? _c('loading-bar') : _vm._e(), _vm._v(" "), (_vm.end) ? _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("No More Log Entries")]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Academy id")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("Status")])])])
	}]}

/***/ },
/* 416 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('ul', {
	    staticClass: "progressbar"
	  }, _vm._l((_vm.steps), function(step, index) {
	    return _c('li', {
	      class: _vm.currentStep >= index ? 'active' : ''
	    }, [_vm._v(_vm._s(step))])
	  }))])
	},staticRenderFns: []}

/***/ },
/* 417 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "editor"
	  }, [_c('h1', [_vm._v("Job Names Mapping Config Editor")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.name),
	      expression: "name",
	      modifiers: {
	        "initial": true
	      }
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "data-vv-rules": "required|uniqueJobName",
	      "name": "toName"
	    },
	    domProps: {
	      "value": _vm._s(_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-window-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancel")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.finish
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Finish and Save")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
	    staticClass: "text-danger"
	  }, [(_vm.errors.has('toName')) ? _c('li', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('toName')))]) : _vm._e(), _vm._v(" "), (_vm.errors.has('hsNames')) ? _c('li', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('hsNames')))]) : _vm._e(), _vm._v(" "), (_vm.available.length === 0) ? _c('li', {
	    staticClass: "text-danger"
	  }, [_vm._v("There are no available job names. You will need to either remove some from another job name config or add the approriate job name in Hot Schedules.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "hs-names"
	  }, [_c('draggable', {
	    staticClass: "draglist",
	    attrs: {
	      "list": _vm.hsNames,
	      "options": _vm.hsOptions
	    },
	    on: {
	      "add": _vm.updateHsNameCount,
	      "remove": _vm.updateHsNameCount
	    }
	  }, _vm._l((_vm.hsNames), function(name) {
	    return _c('div', {
	      staticClass: "hs-name"
	    }, [_vm._v(_vm._s(name))])
	  }))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hsNameCount),
	      expression: "hsNameCount"
	    }, {
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.hsNameCount),
	      expression: "hsNameCount",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    attrs: {
	      "type": "hidden",
	      "name": "hsNames",
	      "data-vv-rules": "notEmptyList|required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.hsNameCount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hsNameCount = $event.target.value
	      }
	    }
	  }), _vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "available-names"
	  }, [_c('draggable', {
	    staticClass: "draglist",
	    attrs: {
	      "list": _vm.available,
	      "options": _vm.availableOptions
	    },
	    on: {
	      "start": function($event) {
	        _vm.dragging = true
	      }
	    }
	  }, _vm._l((_vm.available), function(name) {
	    return _c('div', {
	      staticClass: "available-job"
	    }, [_vm._v(_vm._s(name))])
	  }))])])]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('h3', [_c('i', {
	    staticClass: "fa fa-arrow-circle-left pull-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("Schoox Job Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('h3', [_c('i', {
	    staticClass: "fa fa-arrow-circle-left pull-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("Hot Schedules Job Names")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('h3', [_vm._v("Available Jobs")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "group"
	  }, [_c('p', {
	    staticClass: "editor-instructions text-center"
	  }, [_vm._v("Add/Remove Job Names by dragging them."), _c('br'), _vm._v(" Note: any jobs used in another configuration row will not appear in the available jobs list.")])])])])
	}]}

/***/ },
/* 418 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "info"
	  }, [_c('p', [_vm._v("The Schoox HotSchedules Integration Administration system handles mappings between Schoox Academies and HotSchedules locations, manages configurations of those mappings, synchronizes Schoox user records based on HotSchedules user information, and provides tools for troubleshooting and problem-solving.")])])
	}]}

/***/ },
/* 419 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "err"
	  }, [(_vm.err) ? _c('p', {
	    staticClass: "err-msg"
	  }, [_vm._v(_vm._s(_vm.err) + " "), _c('span', {
	    staticClass: "reload-link",
	    on: {
	      "click": _vm.reload
	    }
	  }, [_vm._v("Reload Page")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 420 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }],
	    staticClass: "login-form bg-light-green shadow-2"
	  }, [(_vm.formSubmitted) ? _c('div', {
	    staticClass: "spinner pull-right"
	  }) : _vm._e(), _c('h2', [_vm._v("Login")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.error) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (!_vm.formSubmitted) ? _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.validateBeforeSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }, {
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.email),
	      expression: "email",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-rules": "required|email",
	      "type": "email",
	      "placeholder": "Username"
	    },
	    domProps: {
	      "value": _vm._s(_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }, {
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: (_vm.password),
	      expression: "password",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "data-vv-rules": "required",
	      "placeholder": "password"
	    },
	    domProps: {
	      "value": _vm._s(_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e()]), _vm._v(" "), _vm._m(0)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "form-group clearfix"
	  }, [_c('button', {
	    staticClass: "button raised pull-right"
	  }, [_vm._v("Submit")])])
	}]}

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    staticClass: "header bg-blue-grey"
	  }, [_vm._m(0), _vm._v(" "), _c('UserActions'), _vm._v(" "), _c('h2', {
	    staticClass: "color-light-green"
	  }, [_vm._v(_vm._s(_vm.app.title) + " "), _c('span', {
	    staticClass: "version"
	  }, [_vm._v("v" + _vm._s(_vm.app.version))])])]), _vm._v(" "), _c('AppMenu'), _vm._v(" "), _c('Err'), _vm._v(" "), _c('div', {
	    staticClass: "app-body"
	  }, [(_vm.loading) ? _c('loading-bar') : _vm._e(), _vm._v(" "), _c('router-view')])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "logo"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(381)
	    }
	  })])
	}]}

/***/ },
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// dist/js/app.3e0a1c6bc6bf79b4de22.js